import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil, startWith, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface ApsFormlySchema {
  aps_intake_report: Array<FormlyFieldConfig>;
  client_identification_demographics: Array<FormlyFieldConfig>;
  closing_summary: Array<FormlyFieldConfig>;
  investigation: Array<FormlyFieldConfig>;
}

const onDestroy$ = new Subject<void>();
const disabledIntakeSection = true;
const fccOnly = sessionStorage.getItem('fcc_only') ? '' : 'hide-asterisk';

export const APS_FORMLY: ApsFormlySchema = {
  aps_intake_report: [
    {
      key: 'aps_report_load',
      wrappers: [
        'getcare-panel'
      ],
      templateOptions: {
        label: 'APS INTAKE REPORT',
        open: true,
        isDisabled: true
      },
      className: 'col-12',
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          id: 'main',
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              template: '<div>CONFIDENTIAL REPORT - NOT SUBJECT TO PUBLIC DISCLOSURE</div>',
              className: 'col-12'
            },
            {
              className: 'col-lg-6 col-md-12 col-12',
              type: 'getcare-select',
              key: 'received_by',
              templateOptions: {
                label: 'Received by',
                placeholder: ' ',
                required: true,
                fieldClass: 'form-control form-control-lg',
                lookUpType: 'received_by',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-6 col-md-12 col-12',
              type: 'getcare-select',
              key: 'type',
              templateOptions: {
                label: 'Type',
                placeholder: ' ',
                lookUpType: 'type',
                required: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-checkbox',
              key: 'unidentified_first_name',
              templateOptions: {
                label: 'Does the victim or authorized representative of victim consent to disclosure of info? (Ombudsman referrals only.)',
                labelClass: 'small',
                disabled: disabledIntakeSection
              }
            },
            {
              type: 'getcare-input',
              key: 'date_completed',
              templateOptions: {
                label: 'Date Completed:',
                labelClass: 'col-lg-2 col-12',
                valueClass: 'col-lg-2 col-12',
                inline: true,
                disabled: disabledIntakeSection,
                fieldClass: 'form-control form-control-lg',
              },
              className: 'col-12',
              wrappers: [
                'getcare-form-field'
              ]
            }
          ]
        },
        {
          id: 'aps_case_reporting_party',
          key: 'aps_case_reporting_party',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'A. Reporting Party Information',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                hideAddTextLabel: true,
                hideRemoveTextLabel: true
              },
              fieldArray: {
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'reporting_category',
                    templateOptions: {
                      label: 'Category',
                      placeholder: ' ',
                      lookUpType: 'reporting_category',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'report_source',
                    templateOptions: {
                      label: 'Report Source',
                      placeholder: ' ',
                      lookUpType: '',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      cascadingHooks: 'reporting_category',
                      cascadingList: {
                        Mandated: 'report_source_mandated',
                        'Non-Mandated': 'report_source_non_mandated',
                        'Financial Institutions': 'report_source_financial'
                      },
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-select',
                    key: 'reporter_an_employee_of_skill_home',
                    templateOptions: {
                      label: 'Is the reporter an employee of a Nursing Home or a Skilled Nursing Facility?',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'reporter_choose_to_remain_anonymous',
                    templateOptions: {
                      label: 'Reporter chooses to remain anonymous',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'name_of_business',
                    templateOptions: {
                      label: 'Agency/Name of Business',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    },
                    hideExpression: 'model.reporter_choose_to_remain_anonymous === "Yes"'
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'first_name',
                    templateOptions: {
                      label: 'First Name',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    },
                    hideExpression: 'model.reporter_choose_to_remain_anonymous === "Yes"'
                  },
                  {
                    className: 'col-lg-4 col-md-12 col-12',
                    type: 'getcare-input',
                    key: 'reporter_title',
                    templateOptions: {
                      label: 'Reporter Title',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-select',
                    key: 'reporter_kinship_relationship',
                    templateOptions: {
                      label: 'Reporters Kinship Relationship',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-textarea',
                    key: 'how_reporter_knows_of_abuse',
                    templateOptions: {
                      label: 'How reporter knows of abuse',
                      rows: 5,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 cold-md-6 col-12',
                        fieldGroupClassName: 'p-2 row',
                        fieldGroup: [
                          {
                            key: 'addresses',
                            type: 'getcare-address-component',
                            className: 'border border-secondary col-12 p-2',
                            templateOptions: {
                              addTextLabel: '<i class="fa fa-plus"></i> Add',
                              removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                              diffLookUpType: 'perpetrator_address_type',
                              disabled: disabledIntakeSection,
                              hasDeleted: true
                            }
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 cold-md-6 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-12',
                            fieldGroupClassName: 'p-2 row',
                            fieldGroup: [
                              {
                                key: 'phones',
                                type: 'getcare-phone-number-component',
                                className: 'col-12 border border-secondary p-2',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  disabled: disabledIntakeSection,
                                  hasDeleted: true
                                }
                              },
                              {
                                key: 'emails',
                                type: 'getcare-email-component',
                                className: 'col-12 border border-secondary p-2 mt-2',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  disabled: disabledIntakeSection,
                                  hasDeleted: true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'victims',
          key: 'victims',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'B. Client Information',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                hideAddTextLabel: true,
                hideRemoveTextLabel: true,
                disabled: disabledIntakeSection
              },
              fieldArray: {
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-3 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-6 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_last_name',
                    templateOptions: {
                      label: 'Unidentified',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'first_name',
                    templateOptions: {
                      label: 'First Name',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-6 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_first_name',
                    templateOptions: {
                      label: 'Unidentified',
                      labelClass: 'small',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-date',
                    key: 'date_of_birth',
                    templateOptions: {
                      label: 'DOB',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      dateType: 'birthDate',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'age',
                    templateOptions: {
                      label: 'Age',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-12 col-12',
                    type: 'getcare-input',
                    key: 'ssn',
                    templateOptions: {
                      label: 'SSN',
                      placeholder: 'SSN',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    },
                    hideExpression: (model, formState, field) => {
                      return field.options.formState.isOffline;
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-12 col-12',
                    // tslint:disable-next-line: max-line-length
                    template: '<label class="font-weight-bold">SSN</label><div class="form-control-lg">XX-XXX-XXXX</div>',
                    hideExpression: (model, formState, field) => {
                      return !field.options.formState.isOffline;
                    }
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 cold-md-6 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'border border-secondary col-12 p-2',
                            fieldGroupClassName: 'p-2 row',
                            fieldGroup: [
                              {
                                type: 'getcare-repeat-component',
                                className: 'col-12',
                                key: 'victim_address',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  hasDeleted: true
                                },
                                defaultValue: [{}],
                                fieldArray: {
                                  className: 'col-12',
                                  fieldGroupClassName: 'mb-2 row',
                                  fieldGroup: [
                                    {
                                        type: 'input',
                                        key: 'address_id',
                                        className: 'hide',
                                        templateOptions: {
                                            type: 'hidden',
                                            hideLabel: true,
                                        },
                                    },
                                    {
                                        type: 'input',
                                        key: 'address_type_id',
                                        className: 'hide',
                                        templateOptions: {
                                            type: 'hidden',
                                            hideLabel: true,
                                        },
                                    },
                                    {
                                        type: 'input',
                                        key: 'county_type_id',
                                        className: 'hide',
                                        templateOptions: {
                                            type: 'hidden',
                                            hideLabel: true,
                                        },
                                    },
                                    {
                                        className: 'col-lg-6 col-md-6 col-12',
                                        type: 'getcare-select',
                                        key: 'address_type',
                                        templateOptions: {
                                          placeholder: 'Select Address Type',
                                          hideLabel: true,
                                          lookUpType: 'work_home_mailing_address_temporary_business',
                                          isRepeatType: true,
                                          fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-6 col-md-6 col-12',
                                        type: 'getcare-select',
                                        key: 'address_county',
                                        templateOptions: {
                                          placeholder: 'Select County',
                                          hideLabel: true,
                                          lookUpType: 'county_with_unknown',
                                          isRepeatType: true,
                                          fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-12',
                                        type: 'getcare-input',
                                        key: 'address_lineone',
                                        templateOptions: {
                                            placeholder: 'Address Line 1',
                                            hideLabel: true,
                                            fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-12',
                                        type: 'getcare-input',
                                        key: 'address_linetwo',
                                        templateOptions: {
                                            placeholder: 'Address Line 2',
                                            hideLabel: true,
                                            fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-4 col-md-4 col-12',
                                        type: 'getcare-input',
                                        key: 'address_city',
                                        templateOptions: {
                                            placeholder: 'City',
                                            hideLabel: true,
                                            fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-4 col-md-4 col-12',
                                        type: 'getcare-select',
                                        key: 'address_state',
                                        templateOptions: {
                                          placeholder: 'Select State',
                                          hideLabel: true,
                                          lookUpType: 'addrstate',
                                          isRepeatType: true,
                                          fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-4 col-md-4 col-12',
                                        type: 'getcare-input',
                                        key: 'address_zip',
                                        templateOptions: {
                                            placeholder: 'Zip',
                                            hideLabel: true,
                                            fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-6 col-md-6 col-12',
                                        type: 'getcare-date',
                                        key: 'address_datefrom',
                                        templateOptions: {
                                            placeholder: 'Valid Date From',
                                            hideLabel: true,
                                            dateType: 'dateRangeFrom',
                                            getValueFrom: 'address_dateto',
                                            fieldClass: 'form-control form-control-lg',
                                        },
                                    },
                                    {
                                        className: 'col-lg-6 col-md-6 col-12',
                                        type: 'getcare-date',
                                        key: 'address_dateto',
                                        templateOptions: {
                                            placeholder: 'Valid Date To',
                                            hideLabel: true,
                                            dateType: 'dateRangeTo',
                                            getValueFrom: 'address_datefrom',
                                            fieldClass: 'form-control form-control-lg',
                                        }
                                    }
                                  ]
                                }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 cold-md-6 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-12',
                            fieldGroupClassName: 'p-2 row',
                            fieldGroup: [
                              {
                                key: 'victim_phone',
                                type: 'getcare-phone-number-component',
                                className: 'col-12 border border-secondary p-2',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  diffPhoneType: 'victim_phone_type',
                                  disabled: disabledIntakeSection,
                                  hasDeleted: true
                                }
                              },
                              {
                                key: 'victim_email',
                                type: 'getcare-email-component',
                                className: 'col-12 border border-secondary p-2 mt-2',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  disabled: disabledIntakeSection,
                                  hasDeleted: true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-textarea',
                    key: 'directions_to_home',
                    templateOptions: {
                      label: 'Directions to Home',
                      rows: 3,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-textarea',
                    key: 'notes',
                    templateOptions: {
                      label: 'Notes',
                      rows: 3,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    fieldGroupClassName: 'border border-secondary p-2 mt-2 row no-gutters d-block',
                    fieldGroup: [
                      {
                        // tslint:disable-next-line: max-line-length
                        template: '<span>\n                                <span class="fs-13 font-weight-bold">APS Worker Safety Concerns</span>\n                                Are there any potential dangers to the worker visiting the client? (e.g., aggressive pet;\n                                  weapons; property hazards; potentially abusive person on site, etc.):</span>'
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-radio',
                        key: 'concerns_are',
                        wrappers: [
                          'getcare-form-field'
                        ],
                        templateOptions: {
                          label: 'Concerns are',
                          labelClass: 'float-left mx-3',
                          formCheck: 'inline',
                          lookUpType: 'known_unknown',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-rich-text-editor',
                        key: 'are_there_any_potential_dangers',
                        templateOptions: {
                          hideLabel: true,
                          rows: 5,
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        hideExpression: (model) => {
                          if (model.concerns_are === 'Unknown') {
                            return true;
                          }
                          return false;
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-12 mt-2',
                    type: 'getcare-checkbox',
                    key: 'present_location_is_different_from_the_above',
                    templateOptions: {
                      label: 'Present Location is different from the above',
                      labelClass: 'small',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-12 mt-2',
                    type: 'getcare-checkbox',
                    key: 'homeless',
                    templateOptions: {
                      label: 'Homeless?',
                      labelClass: 'small',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-select',
                    key: 'loss_of_housing_within_the_last_three_months',
                    templateOptions: {
                      label: 'Client has had a loss of housing within the last 3 months',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    key: 'demographics',
                    fieldGroupClassName: 'row',
                    className: 'col-12',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'homebound',
                        templateOptions: {
                          label: 'Homebound',
                          placeholder: ' ',
                          lookUpType: 'yes_no_declined_to_state',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'gender',
                        templateOptions: {
                          label: 'Gender',
                          placeholder: ' ',
                          lookUpType: 'demographics_gender',
                          required: true,
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'res_hab',
                        templateOptions: {
                          label: 'RES HAB',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12 res_hab_text',
                        type: 'getcare-input',
                        key: 'res_hab_text',
                        templateOptions: {
                          label: '    ',
                          placeholder: 'Please Describe',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        hideExpression: (model) => {
                          if (model.res_hab !== 'Yes') {
                            delete model.res_hab_text;
                            return true;
                          }
                          return false;
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'transgender',
                        templateOptions: {
                          label: 'Transgender',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'urban_rural',
                        templateOptions: {
                          label: 'Urban/Rural Status',
                          placeholder: ' ',
                          lookUpType: 'urban_rural',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'sexual_orientation',
                        templateOptions: {
                          label: 'Sexual Orientation',
                          placeholder: ' ',
                          lookUpType: 'sexual_orientation',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'ethnicity',
                        templateOptions: {
                          label: 'Ethnicity',
                          placeholder: ' ',
                          lookUpType: 'aps_intake_ethnicity',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'multi_race',
                        templateOptions: {
                          label: 'Race',
                          placeholder: ' ',
                          lookUpType: 'race',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection,
                          multiple: true
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'english_fluency',
                        templateOptions: {
                          label: 'English Fluency',
                          placeholder: ' ',
                          lookUpType: 'english_fluency',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'consumer_speak_english',
                        templateOptions: {
                          label: 'Does the consumer speak English?',
                          placeholder: ' ',
                          lookUpType: 'yes_no_declined_to_state',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12 primary_language_other',
                        type: 'getcare-input',
                        key: 'primary_language_other',
                        templateOptions: {
                          label: '    ',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        hideExpression: (model) => {
                          if (model.consumer_speak_english !== 'No') {
                            delete model.primary_language_other;
                            return true;
                          }
                          return false;
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'marital_status',
                        templateOptions: {
                          label: 'Marital Status',
                          placeholder: ' ',
                          lookUpType: 'marital_status',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'schooling_level',
                        templateOptions: {
                          label: 'Schooling Level',
                          placeholder: ' ',
                          lookUpType: 'schooling_level',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'lives_alone',
                        templateOptions: {
                          label: 'Lives Alone',
                          placeholder: ' ',
                          lookUpType: 'yes_no_declined_to_state',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'lives_in_nursing_home_facility',
                        templateOptions: {
                          label: 'Lives in Nursing Home/Skilled Nursing Facility:',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        hideExpression: (model) => {
                          if (model.lives_alone !== 'Yes') {
                            delete model.lives_in_nursing_home_facility;
                            return true;
                          }
                          return false;
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'employment_status',
                        templateOptions: {
                          label: 'Employment Status',
                          placeholder: ' ',
                          lookUpType: 'employment_status',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12 employment_status_other_txt',
                        type: 'getcare-input',
                        key: 'employment_status_other_txt',
                        templateOptions: {
                          label: ' ',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        hideExpression: (model) => {
                          if (model.employment_status !== 'Other') {
                            delete model.employment_status_other_txt;
                            return true;
                          }
                          return false;
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'veteran_status',
                        templateOptions: {
                          label: 'Veteran Status',
                          placeholder: ' ',
                          lookUpType: 'aps_intake_veteran_status',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-12',
                        type: 'getcare-select',
                        key: 'income_level',
                        templateOptions: {
                          label: 'Is the consumer\'s household income',
                          placeholder: ' ',
                          lookUpType: 'is_the_consumer_s_household_income',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-select',
                        key: 'has_case_manager',
                        templateOptions: {
                          label: 'Does the client have a Case Manager?',
                          placeholder: ' ',
                          lookUpType: 'yes_no_unkown',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'referral_criteria',
          key: 'referral_criteria',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'C. Reported Vulnerability and Maltreatment',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              className: 'col-12',
              type: 'getcare-rich-text-editor',
              key: 'reason_for_calling',
              templateOptions: {
                label: 'Reason for calling (identify observations, beliefs and statements made by reporter).',
                rows: 5,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              type: 'getcare-radio',
              key: 'loss_of_key_member_support_for_life_sustaining_activities',
              templateOptions: {
                description: '',
                label:
                  // tslint:disable-next-line: max-line-length
                  'Client has experienced a loss of key member support for life sustaining activities within 3 months of the date of the report.',
                labelClass: 'col-lg-10 col-md-8 col-12',
                valueClass: 'col-lg-2 col-md-4 col-12',
                formCheck: 'inline',
                required: false,
                inline: true,
                lookUpType: 'yes_no',
                disabled: disabledIntakeSection
              },
              className: 'col-12',
              hooks: {},
              modelOptions: {},
              wrappers: ['getcare-form-field'],
            },
            {
              type: 'getcare-radio',
              key: 'client_was_discharged_from_a_hospital_within_the_past_two_weeks',
              templateOptions: {
                description: '',
                label:
                  // tslint:disable-next-line: max-line-length
                  'Client was discharged from a hospital within the past two weeks from date of report and there are concerns due to lack of ability to follow through on their general care.',
                labelClass: 'col-lg-10 col-md-8 col-12',
                valueClass: 'col-lg-2 col-md-4 col-12',
                formCheck: 'inline',
                required: false,
                inline: true,
                lookUpType: 'yes_no',
                disabled: disabledIntakeSection
              },
              className: 'col-12',
              hooks: {},
              modelOptions: {},
              wrappers: ['getcare-form-field'],
            },
            {
              type: 'getcare-radio',
              key: 'client_presents_a_danger_to_themselves_or_others',
              templateOptions: {
                description: '',
                label:
                  // tslint:disable-next-line: max-line-length
                  'Client presents a danger to themselves or others.',
                labelClass: 'col-lg-10 col-md-8 col-12',
                valueClass: 'col-lg-2 col-md-4 col-12',
                formCheck: 'inline',
                required: true,
                inline: true,
                lookUpType: 'yes_no',
                disabled: disabledIntakeSection
              },
              className: 'col-12',
              hooks: {},
              modelOptions: {},
              wrappers: ['getcare-form-field'],
            },
            {
              template: '<div>A. Alleged Vulnerability</div>',
              className: 'col-12 font-weight-bold'
            },
            {
              className: 'ml-lg-3 col-lg-2 col-md-3 col-12',
              type: 'getcare-checkbox',
              key: 'vulnerability_mental',
              templateOptions: {
                label: 'Mental',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-2 col-md-3 col-12',
              type: 'getcare-checkbox',
              key: 'vulnerability_physical',
              templateOptions: {
                label: 'Physical',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-7 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'vulnerability_unknown',
              templateOptions: {
                label: 'Vulnerability Unknown',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-textarea',
              key: 'mental_and_physical_vulnerability_comments',
              templateOptions: {
                rows: 2,
                hideLabel: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              template: '<div>B. Alleged Maltreatment</div>',
              className: 'col-12 font-weight-bold'
            },
            {
              className: 'ml-lg-3 col-lg-1 col-md-2 col-12',
              type: 'getcare-checkbox',
              key: 'alleged_maltreatment_abuse',
              templateOptions: {
                label: 'Abuse',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-1 col-md-3 col-12',
              type: 'getcare-checkbox',
              key: 'alleged_maltreatment_neglect',
              templateOptions: {
                label: 'Neglect',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-2 col-md-3 col-12 mx-lg-2',
              type: 'getcare-checkbox',
              key: 'alleged_maltreatment_exploitation',
              templateOptions: {
                label: 'Exploitation',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-5 col-md-4 col-12',
              type: 'getcare-checkbox',
              key: 'alleged_maltreatment_self_neglect',
              templateOptions: {
                label: 'Self-Neglect',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-textarea',
              key: 'abuse_neglect_exploitation_comments',
              templateOptions: {
                rows: 2,
                hideLabel: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-radio',
              key: 'referral_criteria_been_identified',
              wrappers: [
                'getcare-form-field'
              ],
              templateOptions: {
                // tslint:disable-next-line: max-line-length
                label: '1. Have A and B Referral Criteria been identified or is the reporter?',
                labelClass: 'float-left mr-3',
                formCheck: 'inline',
                required: true,
                lookUpType: 'yes_no_proceed',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-select',
              key: 'is_the_reporter_an_employee_of_a_nh_snf',
              templateOptions: {
                label: '2. Is the reporter an employee of a Nursing Home or a Skilled Nursing Facility?',
                placeholder: ' ',
                lookUpType: 'yes_no',
                required: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-5 col-md-12 col-12 mt-2',
              type: 'getcare-select',
              key: 'is_the_reporter_an_employee_of_a_nh_snf',
              templateOptions: {
                label: 'Is the reporter an employee of a NH/SNF?',
                placeholder: ' ',
                lookUpType: 'yes_no',
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              },
              hideExpression: 'model.referral_criteria_been_identified !== "No - Proceed to Screen Out"'
            },
            {
              className: 'w-100'
            },
            {
              className: 'col-lg-5 col-md-12 col-12 mt-2',
              type: 'getcare-select',
              key: 'alleged_perpetrator_still_have_access_to_the_victim',
              templateOptions: {
                label: 'Does the alleged perpetrator still have access to the victim?',
                placeholder: ' ',
                lookUpType: 'yes_no_unkown',
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            }
          ]
        },
        {
          id: 'perpetration_abuse_result',
          key: 'perpetration_abuse_result',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'D. Reported Type of Maltreatment',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: '<i class="fa fa-plus"></i>',
                removeTextLabel: '<i class="fa fa-minus"></i>',
                disabled: disabledIntakeSection
              },
              fieldArray: {
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-12 col-md-12 col-12',
                    type: 'getcare-select',
                    key: 'type_of_maltreatment',
                    templateOptions: {
                      label: 'Type',
                      placeholder: ' ',
                      lookUpType: 'type_of_maltreatment',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-textarea',
                    key: 'other_type_of_maltreatment',
                    templateOptions: {
                      hideLabel: true,
                      rows: 5,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    },
                    hideExpression: 'model.type_of_maltreatment !== "Other"'
                  },
                  {
                    template: '<div>Maltreatment resulted in:</div>',
                    className: 'col-lg-12 col-md-12 col-12 mb-3 font-weight-bold'
                  },
                  {
                    className: 'col-lg-12 col-md-12 col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'physical_injury',
                        templateOptions: {
                          label: 'Physical Injury',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'minor_medical_care',
                        templateOptions: {
                          label: 'Minor Medical Care',
                          disabled: disabledIntakeSection
                        },
                       /*  expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'hospitalization',
                        templateOptions: {
                          label: 'Hospitalization',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'care_provider_required',
                        templateOptions: {
                          label: 'Care Provider Required',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'death',
                        templateOptions: {
                          label: 'Death',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'mental_suffering',
                        templateOptions: {
                          label: 'Mental Suffering',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'unknown',
                        templateOptions: {
                          label: 'Unknown',
                          disabled: disabledIntakeSection
                        },
                        // expressionProperties: {
                          // tslint:disable-next-line: max-line-length
                          'templateOptions.disabled': 'model.not_applicable || model.physical_injury || model.minor_medical_care || model.hospitalization || model.care_provider_required || model.death || model.other || model.mental_suffering'
                        // }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'other',
                        templateOptions: {
                          label: 'Other (Specify)',
                          disabled: disabledIntakeSection
                        },
                        /* expressionProperties: {
                          'templateOptions.disabled': 'model.unknown || model.not_applicable'
                        } */
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-checkbox',
                        key: 'not_applicable',
                        templateOptions: {
                          label: 'Not Applicable',
                          disabled: disabledIntakeSection
                        },
                        // expressionProperties: {
                          // tslint:disable-next-line: max-line-length
                          'templateOptions.disabled': 'model.unknown || model.physical_injury || model.minor_medical_care || model.hospitalization || model.care_provider_required || model.death || model.other || model.mental_suffering'
                        // }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-textarea',
                    key: 'other_maltreatment_result',
                    templateOptions: {
                      hideLabel: true,
                      rows: 5,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    },
                    hideExpression: '!model.other',
                    /* expressionProperties: {
                      'model.other_maltreatment_result': '!model.other ? "" : model.other_maltreatment_result'
                    } */
                  },
                  {
                    type: 'getcare-repeat-component',
                    className: 'col-12',
                    key: 'financial_accounts',
                    templateOptions: {
                      addTextLabel: '<i class="fa fa-plus"></i> Add',
                      removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                      hasDeleted: true
                    },
                    hideExpression: (model, formState, field) => {
                      return field.parent.formControl.get('type_of_maltreatment').value !== "Financial exploitation";
                    },
                    defaultValue: [{}],
                    fieldArray: {
                      className: 'col-12',
                      fieldGroupClassName: 'mb-2 row',
                      fieldGroup: [
                        {
                          type: 'getcare-input',
                          key: 'account_number_last_four_digits',
                          templateOptions: {
                            label: 'Account Number (last 4 digits):',
                            labelClass: 'col-lg-8 col-12',
                            valueClass: 'col-lg-4 col-12',
                            inline: true,
                            disabled: disabledIntakeSection
                          },
                          className: 'col-lg-6 col-12',
                          wrappers: [
                            'getcare-form-field'
                          ]
                        },
                        {
                          type: 'getcare-input',
                          key: 'type_of_account',
                          templateOptions: {
                            label: 'Type of account',
                            labelClass: 'col-lg-5 col-12',
                            valueClass: 'col-lg-7 col-12',
                            inline: true,
                            disabled: disabledIntakeSection
                          },
                          className: 'col-lg-6 col-12',
                          wrappers: [
                            'getcare-form-field'
                          ]
                        },
                        {
                          className: 'col-lg-6 col-12',
                          type: 'getcare-select',
                          key: 'trust_account',
                          templateOptions: {
                            label: 'Trust account:',
                            placeholder: ' ',
                            lookUpType: 'yes_no',
                            fieldClass: 'form-control form-control-lg',
                            disabled: disabledIntakeSection
                          }
                        },
                        {
                          className: 'col-lg-6 col-12',
                          type: 'getcare-select',
                          key: 'power_of_attorney',
                          templateOptions: {
                            label: 'Power of attorney:',
                            placeholder: ' ',
                            lookUpType: 'yes_no',
                            fieldClass: 'form-control form-control-lg',
                            disabled: disabledIntakeSection
                          }
                        },
                        {
                          className: 'col-lg-6 col-12',
                          type: 'getcare-select',
                          key: 'direct_deposit',
                          templateOptions: {
                            label: 'Direct Deposit:',
                            placeholder: ' ',
                            lookUpType: 'yes_no',
                            fieldClass: 'form-control form-control-lg',
                            disabled: disabledIntakeSection
                          }
                        },
                        {
                          className: 'col-lg-6 col-12',
                          type: 'getcare-select',
                          key: 'other_accounts',
                          templateOptions: {
                            label: 'Other accounts:',
                            placeholder: ' ',
                            lookUpType: 'yes_no',
                            fieldClass: 'form-control form-control-lg',
                            disabled: disabledIntakeSection
                          }
                        },
                      ]
                    }
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'incident_addresses',
          key: 'incident_addresses',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'E. Incident Information',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                hideAddTextLabel: true,
                hideRemoveTextLabel: true,
                disabled: disabledIntakeSection
              },
              fieldArray: {
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'maltreatment_setting',
                    templateOptions: {
                      label: 'Maltreatment Setting',
                      placeholder: ' ',
                      lookUpType: 'maltreatment_setting',
                      required: true,
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'place_of_incident',
                    templateOptions: {
                      label: 'Place of incident',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-checkbox',
                    key: 'address_same_as_client',
                    templateOptions: {
                      label: 'Address is the same as the client',
                      change: field => {
                        const clientAddr = field.options.formState.clientAddress;
                        if (field.form.get('address_same_as_client').value) {
                          field.form.get('address_incident_occurred').setValue({
                            address_type: clientAddr.address_type,
                            county: clientAddr.address_county,
                            addrlineone: clientAddr.address_lineone,
                            addrlinetwo: clientAddr.address_linetwo,
                            addrcity: clientAddr.address_city,
                            addrstate: clientAddr.address_state,
                            addrzip: clientAddr.address_zip
                          });
                        } else {
                          field.form.get('address_incident_occurred').setValue({
                            address_type: '',
                            county: '',
                            addrlineone: '',
                            addrlinetwo: '',
                            addrcity: '',
                            addrstate: '',
                            addrzip: ''
                          });
                        }
                      },
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    key: 'address_incident_occurred',
                    fieldGroupClassName: 'mb-2 row',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12 mt-2',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12 mt-2',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          placeholder: 'Address Line 1',
                          hideLabel: true,
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg',
                          hideLabel: true,
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg',
                          hideLabel: true,
                          disabled: disabledIntakeSection
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg',
                          disabled: disabledIntakeSection
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrzip',
                        templateOptions: {
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg',
                          hideLabel: true,
                          disabled: disabledIntakeSection
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-4 col-md-12 col-12',
                    type: 'getcare-select',
                    key: 'occurrence',
                    templateOptions: {
                      label: 'The occurrence is',
                      placeholder: ' ',
                      lookUpType: 'occurrence',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-date',
                    key: 'date',
                    templateOptions: {
                      label: 'Date',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-lg-4 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'time',
                    templateOptions: {
                      label: 'Time',
                      fieldClass: 'form-control form-control-lg',
                      disabled: disabledIntakeSection
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-checkbox',
                    key: 'supplemental_info_attached',
                    templateOptions: {
                      label: 'Check if medical, financial, photographers, or other supplemental information is attached.',
                      disabled: disabledIntakeSection
                    }
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'abusers',
          key: 'abusers',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'F. Alleged Perpetrator Information',
            open: true,
            isDisabled: true,
            isDisableSection: false
          },
          defaultValue: [
            {}
          ],
          expressionProperties: {
            'templateOptions.isDisableSection': (modelArray, modelObject, field) => {
              if ((field.parent.model.referral_criteria !== undefined
                  && field.parent.model.referral_criteria.alleged_maltreatment_self_neglect !== undefined
                  && field.parent.model.referral_criteria.alleged_maltreatment_self_neglect)
                  && !( (field.parent.model.referral_criteria.alleged_maltreatment_abuse !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_abuse)
                      || (field.parent.model.referral_criteria.alleged_maltreatment_neglect !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_neglect)
                      || (field.parent.model.referral_criteria.alleged_maltreatment_exploitation !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_exploitation) )) {
                    return true;
              } else {
                return false;
              }
            }
          },
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove',
                disabled: disabledIntakeSection
              },
              fieldArray: {
                className: 'border border-secondary p-4',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    template: '<div>Name of alleged Perpetrator</div>',
                    className: 'col-12 font-weight-bold'
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      placeholder: 'Last Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_last_name',
                    templateOptions: {
                      label: 'Unidentified'
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12',
                    type: 'getcare-input',
                    key: 'first',
                    templateOptions: {
                      label: 'First Name',
                      placeholder: 'First Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_first_name',
                    templateOptions: {
                      label: 'Unidentified'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'other_name_info',
                    templateOptions: {
                      label: 'Provide any information to help identify the record:',
                      fieldClass: 'form-control form-control-lg',
                    },
                    hideExpression: '!(model.unidentified_first_name || model.unidentified_last_name)'
                  },
                  {
                    className: 'w-100'
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-select',
                    key: 'perpetrator_also_the_caregiver',
                    templateOptions: {
                      label: 'The alleged perpetrator is also the caregiver',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-select',
                    key: 'kinship_relationship',
                    templateOptions: {
                      label: 'Kinship Relationship',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-checkbox',
                    key: 'address_same_as_client',
                    templateOptions: {
                      label: 'Address is the same as the client',
                      change: field => {
                        const clientAddr = field.options.formState.clientAddress;
                        if (field.form.get('address_same_as_client').value) {
                          field.form.get('address').setValue({
                            address_type: clientAddr.address_type,
                            county: clientAddr.address_county,
                            addrlineone: clientAddr.address_lineone,
                            addrlinetwo: clientAddr.address_linetwo,
                            addrcity: clientAddr.address_city,
                            addrstate: clientAddr.address_state,
                            addrzip: clientAddr.address_zip
                          });
                        } else {
                          field.form.get('address').setValue({
                            address_type: '',
                            county: '',
                            addrlineone: '',
                            addrlinetwo: '',
                            addrcity: '',
                            addrstate: '',
                            addrzip: ''
                          });
                        }
                      }
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg'
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrzip',
                        templateOptions: {
                          placeholder: 'Zip',
                          hideLabel: true,
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    template: '<div>Description:</div>',
                    className: 'col-12 font-weight-bold mb-2'
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'gender',
                    templateOptions: {
                      label: 'Gender',
                      placeholder: ' ',
                      lookUpType: 'gender',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'transgender',
                    templateOptions: {
                      label: 'Transgender',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'dob',
                    templateOptions: {
                      label: 'DOB',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'age',
                    templateOptions: {
                      label: 'Age',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'race',
                    templateOptions: {
                      label: 'Race',
                      placeholder: ' ',
                      lookUpType: 'abusers_race',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'ethnicity',
                    templateOptions: {
                      label: 'Ethnicity',
                      placeholder: ' ',
                      lookUpType: 'abusers_ethnicity',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        template: '<div>Approx. Height</div>',
                        className: 'col-12 font-weight-bold mb-1'
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'height_feet',
                        templateOptions: {
                          label: 'Feet',
                          fieldClass: 'form-control form-control-lg',
                          inline: true,
                          labelClass: 'col-lg-5 col-md-6 col-12',
                          valueClass: 'col-lg-7 col-md-6 col-12'
                        },
                        wrappers: [
                          'getcare-form-field'
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'height_inches',
                        templateOptions: {
                          label: 'inches',
                          fieldClass: 'form-control form-control-lg',
                          inline: true,
                          labelClass: 'col-lg-5 col-md-6 col-12',
                          valueClass: 'col-lg-7 col-md-6 col-12'
                        },
                        wrappers: [
                          'getcare-form-field'
                        ]
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        template: '<div>Approx. Weight</div>',
                        className: 'col-12 font-weight-bold mb-1'
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'weight',
                        templateOptions: {
                          hideLabel: true,
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'eyes',
                    templateOptions: {
                      label: 'Eyes',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'hair',
                    templateOptions: {
                      label: 'Hair',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-select',
                        key: 'combination_at_start',
                        templateOptions: {
                          label: 'Cohabitation at Start',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'perpetrator_association_at_start',
                        templateOptions: {
                          label: 'Perpetrator Association at Start',
                          placeholder: ' ',
                          lookUpType: 'caregiver_association_to_victim',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            template: '<div>Perpetrator Substitute Decision Maker at Start</div>',
                            className: 'col-12 font-weight-bold'
                          },
                          {
                            className: 'col-12 mt-3',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'representative_payee',
                                templateOptions: {
                                  label: 'Representative Payee'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship (non specific)'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'financial_proxy_in_Effect',
                                templateOptions: {
                                  label: 'Financial Proxy in Effect'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship_of_person',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Person'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship_of_property',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Property'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'health_care_proxy_in_Effect',
                                templateOptions: {
                                  label: 'Health Care Proxy in Effect'
                                },
                                /* expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                } */
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'none',
                                templateOptions: {
                                  label: 'None'
                                },
                                // expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  // 'templateOptions.disabled': 'model.representative_payee || model.guardianship_or_conservatorship || model.financial_proxy_in_Effect || model.guardianship_or_conservatorship_of_person || model.guardianship_or_conservatorship_of_property || model.health_care_proxy_in_Effect'
                               // }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-12 my-2',
                        fieldGroupClassName: 'row',
                        hideExpression: (model, formState, field) => {
                          if (!(
                              (field.parent.model.address.address_type !== 'Work' && field.parent.model.address.address_type !== 'Business')
                              && (field.parent.model.perpetrator_association_at_start === 'Nursing home staff')
                              || field.parent.model.perpetrator_association_at_start === 'Residential care community staff'
                              || field.parent.model.perpetrator_association_at_start === 'Paid relative caregiver'
                              || field.parent.model.perpetrator_association_at_start === 'Facility staff')) {
                                if (field.parent.form.get('employer_at_time_of_incident') !== null) {
                                  field.parent.form.get('employer_at_time_of_incident').setValue({
                                    address_type: '',
                                    addrlineone: '',
                                    addrlinetwo: '',
                                    addrcity: '',
                                    addrstate: '',
                                    addrzip: '',
                                    employer_telephone: ''
                                  });
                                }
                                return true;
                          }
                          return false;
                        },
                        fieldGroup: [
                          {
                            template: '<div>Perpetrator Employer at time of incident</div>',
                            className: 'col-12 font-weight-bold mb-2'
                          },
                          {
                            key: 'employer_at_time_of_incident',
                            className: 'col-12',
                            fieldGroupClassName: 'row no-gutter',
                            fieldGroup: [
                              {
                                className: 'col-12',
                                type: 'getcare-input',
                                key: 'address_type',
                                templateOptions: {
                                  hideLabel: true,
                                  fieldClass: 'form-control form-control-lg'
                                }
                              },
                              {
                                className: 'col-lg-6 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'addrlineone',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Address Line 1',
                                  fieldClass: 'form-control form-control-lg'
                                }
                              },
                              {
                                className: 'col-lg-6 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'addrlinetwo',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Address Line 2',
                                  fieldClass: 'form-control form-control-lg'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-input',
                                key: 'addrcity',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'City',
                                  fieldClass: 'form-control form-control-lg'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-select',
                                key: 'addrstate',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: ' ',
                                  lookUpType: 'addrstate',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                defaultValue: 'ID'
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-input',
                                key: 'addrzip',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Zip',
                                  fieldClass: 'form-control form-control-lg'
                                }
                              },
                              {
                                className: 'col-12',
                                fieldGroupClassName: 'row no-gutter',
                                fieldGroup: [
                                  {
                                    className: 'col-12',
                                    type: 'getcare-input',
                                    key: 'employer_telephone',
                                    templateOptions: {
                                      label: 'Telephone',
                                      fieldClass: 'form-control form-control-lg'
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'caregivers',
          key: 'caregivers',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'G. Caregiver Information-Person responsible for the client\'s medical or financial care',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove',
                disabled: disabledIntakeSection
              },
              fieldArray: {
                className: 'border border-secondary p-4',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        className: 'col-lg-3 col-md-6 col-12 order-lg-1 order-md-2 order-sm-2 order-2 mt-md-2 mt-lg-0',
                        type: 'getcare-input',
                        key: 'last_name',
                        templateOptions: {
                          label: 'Last Name',
                          placeholder: 'Last Name',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-3 col-md-6 col-12 order-lg-2 order-md-3 order-sm-3 order-3 mt-md-2 mt-lg-0',
                        type: 'getcare-input',
                        key: 'first_name',
                        templateOptions: {
                          label: 'First Name',
                          placeholder: 'First Name',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        type: 'getcare-button',
                        className: 'col-lg-6 col-md-12 col-12 order-lg-3 order-md-1 order-sm-1 order-1',
                        templateOptions: {
                          text: 'Sync with F. Alleged Perpetrator',
                          type: 'getcare-button',
                          btnType: 'primary float-right',
                          fieldClass: 'mb-2 btn-block',
                          disabled: disabledIntakeSection
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'kinship_relationship_to_victim',
                    templateOptions: {
                      label: 'Kinship Relationship to victim',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'caregiver_association_to_victim',
                    templateOptions: {
                      label: 'Caregiver Association to victim',
                      placeholder: ' ',
                      lookUpType: 'caregiver_association_to_victim',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-checkbox',
                    key: 'address_same_as_client',
                    templateOptions: {
                      label: 'Address is the same as the client',
                      change: field => {
                        const clientAddr = field.options.formState.clientAddress;
                        if (field.form.get('address_same_as_client').value) {
                          field.form.get('address').setValue({
                            address_type: clientAddr.address_type,
                            county: clientAddr.address_county,
                            addrlineone: clientAddr.address_lineone,
                            addrlinetwo: clientAddr.address_linetwo,
                            addrcity: clientAddr.address_city,
                            addrstate: clientAddr.address_state,
                            addrzip: clientAddr.address_zip
                          });
                        } else {
                          field.form.get('address').setValue({
                            address_type: '',
                            county: '',
                            addrlineone: '',
                            addrlinetwo: '',
                            addrcity: '',
                            addrstate: '',
                            addrzip: ''
                          });
                        }
                      }
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: ' ',
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg'
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrzip',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'witnesses',
          key: 'witnesses',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'H. Witness or Other person believed to have knowledge of Maltreatment',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove',
                disabled: disabledIntakeSection
              },
              fieldArray: {
                className: 'border border-secondary p-4',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      placeholder: 'Last Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'first_name',
                    templateOptions: {
                      label: 'First Name',
                      placeholder: 'First Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-select',
                    key: 'kinship_relationship_to_victim',
                    templateOptions: {
                      label: 'Kinship Relationship to victim',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-checkbox',
                    key: 'address_same_as_client',
                    templateOptions: {
                      label: 'Address is the same as the client',
                      change: field => {
                        const clientAddr = field.options.formState.clientAddress;
                        if (field.form.get('address_same_as_client').value) {
                          field.form.get('address').setValue({
                            address_type: clientAddr.address_type,
                            county: clientAddr.address_county,
                            addrlineone: clientAddr.address_lineone,
                            addrlinetwo: clientAddr.address_linetwo,
                            addrcity: clientAddr.address_city,
                            addrstate: clientAddr.address_state,
                            addrzip: clientAddr.address_zip
                          });
                        } else {
                          field.form.get('address').setValue({
                            address_type: '',
                            county: '',
                            addrlineone: '',
                            addrlinetwo: '',
                            addrcity: '',
                            addrstate: '',
                            addrzip: ''
                          });
                        }
                      }
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: ' ',
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg'
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrzip',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'receiving_agency',
          key: 'receiving_agency',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'I. Receiving Agency Use Only',
            open: true,
            isDisabled: true
          },
          className: 'mt-1 col-12 px-2',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-input',
              key: 'report_received_by',
              templateOptions: {
                label: '1. Report Received By',
                required: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              template: '<u>Reset</u>',
              className: 'col-lg-2 col-md-6 col-12 pointer'
            },
            {
              className: 'col-lg-4 col-md-6 col-12',
              type: 'getcare-input',
              key: 'report_received_date',
              templateOptions: {
                label: 'Date',
                required: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-input',
              key: 'report_received_time',
              templateOptions: {
                label: 'Time',
                required: true,
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12',
              type: 'getcare-radio',
              key: 'assigned',
              wrappers: [
                'getcare-form-field'
              ],
              templateOptions: {
                label: '2. Assigned',
                labelClass: 'col-lg-2 col-12',
                valueClass: 'col-lg-7 col-12',
                formCheck: 'inline',
                inline: true,
                lookUpType: 'assigned_hours',
                disabled: disabledIntakeSection
              }
            },
            {
              template: '<div>3. Concurrent Reporting</div>',
              className: 'col-12 mb-2 font-weight-bold'
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'local_law_enforcement',
              templateOptions: {
                label: 'Local Law Enforcement',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'local_ombudsman',
              templateOptions: {
                label: 'Local Ombudsman',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'dhw_facility_standards_nh_snf',
              templateOptions: {
                label: 'DHW- Facility Standards NH/SNF',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'dhw_facility_standards_ralf',
              templateOptions: {
                label: 'DHW- Facility Standards RALF',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'dhw_facility_standards_cfh',
              templateOptions: {
                label: 'DHW- Facility Standards CFH',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'dhw_facility_standards_cfh',
              templateOptions: {
                label: 'DHW-Mental Health Services',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'dhw_adult_developmental_disability_services',
              templateOptions: {
                label: 'DHW- Adult Developmental Disability Services',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-lg-3 col-md-6 col-12',
              type: 'getcare-checkbox',
              key: 'board_of_guardians',
              templateOptions: {
                label: 'Board of Guardians',
                disabled: disabledIntakeSection
              }
            },
            {
              className: 'col-12 px-3',
              fieldGroupClassName: '',
              fieldGroup: [
                {
                  className: 'float-left mr-2',
                  type: 'getcare-checkbox',
                  key: 'other',
                  templateOptions: {
                    label: 'Other',
                    disabled: disabledIntakeSection
                  }
                },
                {
                  className: 'float-left',
                  type: 'getcare-input',
                  key: 'other_concurrent_reporting',
                  templateOptions: {
                    hideLabel: true,
                    fieldClass: 'form-control form-control-lg',
                    disabled: disabledIntakeSection
                  }
                }
              ]
            },
            {
              className: 'col-12',
              type: 'getcare-input',
              key: 'law_enforcement_case_file_number',
              templateOptions: {
                label: '4. APS/ Ombudsman/ Law Enforcement Case File Number',
                fieldClass: 'form-control form-control-lg',
                disabled: disabledIntakeSection
              }
            },
            {
              type: 'getcare-textarea',
              templateOptions: {
                placeholder: '',
                description: '',
                label: 'Note:',
                labelClass: '',
                required: false,
                rows: 5,
                disabled: disabledIntakeSection,
                fieldClass: 'form-control form-control-lg'
              },
              key: 'note',
              className: 'col-12',
              hooks: {},
              modelOptions: {},
              wrappers: ['getcare-form-field']
            },
            {
              className: 'col-12',
              type: 'getcare-checkbox',
              key: 'fcc_only',
              templateOptions: {
                label: 'FCC Only'
              }
            },
            {
              className: 'col-12',
              fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
              fieldGroup: [
                {
                  className: 'col-lg-6 col-md-12 col-12',
                  type: 'getcare-input',
                  key: 'approved_by',
                  templateOptions: {
                    label: 'Approved By',
                    fieldClass: 'form-control form-control-lg',
                    disabled: disabledIntakeSection
                  }
                },
                {
                  className: 'col-lg-6 col-md-12 col-12',
                  type: 'getcare-input',
                  key: 'assigned_to',
                  templateOptions: {
                    label: 'Assigned to',
                    fieldClass: 'form-control form-control-lg',
                    disabled: disabledIntakeSection
                  }
                },
                {
                  className: 'col-lg-6 col-md-12 col-12',
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      type: 'getcare-repeat-component',
                      key: 'aps_blocked_user_accesses',
                      className: 'col-12 mb-2 mt-2',
                      templateOptions: {
                        hideAddTextLabel: true,
                        hideRemoveTextLabel: true
                      },
                      fieldArray: {
                        className: 'col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            type: 'getcare-input',
                            key: 'name',
                            templateOptions: {
                              label: 'Blocked User Access',
                              fieldClass: 'form-control form-control-lg',
                              disabled: disabledIntakeSection
                            }
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  type: 'getcare-button',
                  className: 'col-lg-6 col-md-12 col-12',
                  templateOptions: {
                    text: 'Edit',
                    type: 'getcare-button',
                    btnType: 'primary float-right',
                    disabled: disabledIntakeSection
                  }
                }
              ]
            },
            /* {
              type: 'getcare-button',
              className: 'col-12 mt-3',
              templateOptions: {
                text: 'Supervisor Modify Locked Intake',
                type: 'getcare-button',
                btnType: 'primary float-right',
                disabled: disabledIntakeSection
              }
            } */
          ]
        }
      ]
    }
  ],
  client_identification_demographics: [
    {
      key: 'aps_report_load',
      fieldGroup: [
        {
          id: 'victims',
          key: 'victims',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Client Identification & Demographics',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'col-12 mt-1',
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                hideAddTextLabel: true,
                hideRemoveTextLabel: true
              },
              fieldArray: {
                fieldGroup: [
                  {
                    id: 'client_main',
                    className: 'col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-lg-10 col-md-12 col-12 order-lg-last order-md-last order-sm-last order-xs-last my-2',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                className: 'col-lg-6 col-12',
                                id: '1081da4c-d4cf-46ae-8a67-ca1fbb5fafad',
                                fieldGroupClassName: 'row',
                                fieldGroup: [
                                  {
                                    template: '<label class="font-weight-bold">Name: </label>',
                                    className: 'col-lg-4 col-12'
                                  },
                                  {
                                    className: 'col-lg-8 col-12',
                                    fieldGroup: [
                                      {
                                        type: 'getcare-text',
                                        key: 'last_name',
                                        className: 'float-left'
                                      },
                                      {
                                        template: ',',
                                        className: 'float-left'
                                      },
                                      {
                                        type: 'getcare-text',
                                        key: 'first_name',
                                        className: 'float-left ml-2'
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                type: 'getcare-text',
                                templateOptions: {
                                  label: 'Suffix:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'suffix',
                                id: '5296bda2-f364-426c-a008-803fb2d64eb8',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-text',
                                key: 'last_four_of_ssn',
                                templateOptions: {
                                  label: 'SSN:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                id: 'b070f557-7438-4bff-aadd-244e11a3120f',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ],
                                hideExpression: (model, formState, field) => {
                                  return field.options.formState.isOffline;
                                }
                              },
                              {
                                className: 'col-lg-6 col-12',
                                // tslint:disable-next-line: max-line-length
                                template: '<div class="row"><label class="font-weight-bold col-lg-4 col-12">SSN:</label><div class="col-lg-8 col-12">XX-XXX-XXXX</div></div>',
                                hideExpression: (model, formState, field) => {
                                  return !field.options.formState.isOffline;
                                }
                              },
                              {
                                type: 'getcare-text',
                                templateOptions: {
                                  label: 'DOB:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'date_of_birth',
                                id: 'dbf9de54-2348-470a-93b3-1469123d2d03',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-text',
                                templateOptions: {
                                  label: 'Age:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  required: true,
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'age',
                                id: '97b9fe88-eb7e-4e29-87de-2c304d676f09',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-text',
                                key: 'getcare_id',
                                templateOptions: {
                                  label: 'Getcare ID:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                id: '7346041d-f0e6-46a6-b8e7-102fa62549e5',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-input',
                                templateOptions: {
                                  label: 'AKA Last Name:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'aka_lastname',
                                id: 'd63a5569-3e7b-4b8a-a43c-8813e107634d',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-input',
                                templateOptions: {
                                  label: 'AKA First Name:',
                                  labelClass: 'col-lg-4 col-12',
                                  valueClass: 'col-lg-8 col-12',
                                  inline: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'aka_firstname',
                                id: '0ce45096-127d-4016-b063-d3650ee99ffd',
                                className: 'col-lg-6 col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              },
                              {
                                type: 'getcare-select',
                                templateOptions: {
                                  placeholder: 'Select',
                                  label: 'Region',
                                  labelClass: 'col-lg-2 col-12',
                                  valueClass: 'col-lg-10 col-12',
                                  required: true,
                                  inline: true,
                                  lookUpType: 'region',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                key: 'region',
                                id: 'df67a30c-7147-4bb1-bf58-e2c951a09a95',
                                className: 'col-12',
                                wrappers: [
                                  'getcare-form-field'
                                ]
                              }
                            ]
                          },
                          {
                            className: 'col-lg-2 col-md-12 col-12 order-lg-last order-md-first order-sm-first order-xs-first my-2',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                type: 'getcare-image',
                                key: 'client_photo',
                                className: 'col-12',
                                templateOptions: {
                                  fieldClass: 'img-fluid float-right w-100'
                                }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-12',
                        fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
                        fieldGroup: [
                          {
                            className: 'col-lg-6 cold-md-6 col-12',
                            fieldGroupClassName: 'p-2 row',
                            fieldGroup: [
                              {
                                key: 'victim_address',
                                type: 'getcare-address-component',
                                className: 'border border-secondary col-12 p-2',
                                templateOptions: {
                                  addTextLabel: '<i class="fa fa-plus"></i> Add',
                                  removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                  diffAddressType: 'work_home_mailing_address_temporary_business',
                                  diffCounty: 'county_with_unknown',
                                  diffState: 'addr_state',
                                  hasDeleted: true
                                }
                              }
                            ]
                          },
                          {
                            className: 'col-lg-6 cold-md-6 col-12',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                className: 'col-12',
                                fieldGroupClassName: 'p-2 row',
                                fieldGroup: [
                                  {
                                    key: 'victim_phone',
                                    type: 'getcare-phone-number-component',
                                    className: 'col-12 border border-secondary p-2',
                                    templateOptions: {
                                      addTextLabel: '<i class="fa fa-plus"></i> Add',
                                      removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                      diffPhoneType: 'victim_phone_type',
                                      hasDeleted: true
                                    }
                                  },
                                  {
                                    key: 'victim_email',
                                    type: 'getcare-email-component',
                                    className: 'col-12 border border-secondary p-2 mt-2',
                                    templateOptions: {
                                      addTextLabel: '<i class="fa fa-plus"></i> Add',
                                      removeTextLabel: '<i class="fa fa-trash"></i> Remove',
                                      hasDeleted: true
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12 mt-2',
                        type: 'getcare-textarea',
                        key: 'directions_to_home',
                        templateOptions: {
                          label: 'Directions to Home',
                          rows: 3,
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12 mt-2',
                        type: 'getcare-textarea',
                        key: 'notes',
                        templateOptions: {
                          label: 'Notes',
                          rows: 3,
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        fieldGroupClassName: 'border border-secondary p-2 mt-2 row no-gutters d-block',
                        fieldGroup: [
                          {
                            // tslint:disable-next-line: max-line-length
                            template: '<span>\n                                <span class="fs-13 font-weight-bold">APS Worker Safety Concerns</span>\n                                Are there any potential dangers to the worker visiting the client? (e.g., aggressive pet;\n                                  weapons; property hazards; potentially abusive person on site, etc.):</span>'
                          },
                          {
                            className: 'col-12',
                            type: 'getcare-rich-text-editor',
                            key: 'are_there_any_potential_dangers',
                            templateOptions: {
                              hideLabel: true,
                              rows: 5,
                              fieldClass: 'form-control form-control-lg'
                            }
                          }
                        ]
                      }
                    ]
                  },
                  {
                    id: 'demographics',
                    fieldGroupClassName: 'row',
                    className: 'col-12 mt-2',
                    fieldGroup: [
                      {
                        key: 'demographics',
                        fieldGroupClassName: 'row',
                        className: 'col-12 mt-2',
                        fieldGroup: [
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'homebound',
                            templateOptions: {
                              label: 'Homebound',
                              placeholder: ' ',
                              lookUpType: 'yes_no_declined_to_state',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'gender',
                            templateOptions: {
                              label: 'Gender',
                              placeholder: ' ',
                              lookUpType: 'demographics_gender',
                              required: true,
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'res_hab',
                            templateOptions: {
                              label: 'RES HAB',
                              placeholder: ' ',
                              lookUpType: 'yes_no',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12 res_hab_text',
                            type: 'getcare-input',
                            key: 'res_hab_text',
                            templateOptions: {
                              label: '    ',
                              placeholder: 'Please Describe',
                              fieldClass: 'form-control form-control-lg'
                            },
                            hideExpression: (model) => {
                              if (model.res_hab !== 'Yes') {
                                delete model.res_hab_text;
                                return true;
                              }
                              return false;
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'transgender',
                            templateOptions: {
                              label: 'Transgender',
                              placeholder: ' ',
                              lookUpType: 'yes_no',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'urban_rural',
                            templateOptions: {
                              label: 'Urban/Rural',
                              placeholder: ' ',
                              lookUpType: 'urban_rural',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'sexual_orientation',
                            templateOptions: {
                              label: 'Sexual Orientation',
                              placeholder: ' ',
                              lookUpType: 'sexual_orientation',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'ethnicity',
                            templateOptions: {
                              label: 'Ethnicity',
                              placeholder: ' ',
                              lookUpType: 'ethnicity',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'multi_race',
                            templateOptions: {
                              label: 'Race',
                              placeholder: ' ',
                              lookUpType: 'race',
                              fieldClass: 'form-control form-control-lg',
                              multiple: true
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'english_fluency',
                            templateOptions: {
                              label: 'English Fluency',
                              placeholder: ' ',
                              lookUpType: 'english_fluency',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'consumer_speak_english',
                            templateOptions: {
                              label: 'Does the consumer speak English?',
                              placeholder: ' ',
                              lookUpType: 'yes_no_declined_to_state',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12 primary_language_other',
                            type: 'getcare-input',
                            key: 'primary_language_other',
                            templateOptions: {
                              label: '    ',
                              fieldClass: 'form-control form-control-lg'
                            },
                            hideExpression: (model) => {
                              if (model.consumer_speak_english !== 'No') {
                                delete model.primary_language_other;
                                return true;
                              }
                              return false;
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'marital_status',
                            templateOptions: {
                              label: 'Marital Status',
                              placeholder: ' ',
                              lookUpType: 'marital_status',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'schooling_level',
                            templateOptions: {
                              label: 'Schooling Level',
                              placeholder: ' ',
                              lookUpType: 'schooling_level_client_ident',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'lives_alone',
                            templateOptions: {
                              label: 'Lives Alone',
                              placeholder: ' ',
                              lookUpType: 'yes_no_declined_to_state',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'lives_in_nursing_home_facility',
                            templateOptions: {
                              label: 'Lives in Nursing Home/Skilled Nursing Facility:',
                              placeholder: ' ',
                              lookUpType: 'yes_no',
                              fieldClass: 'form-control form-control-lg'
                            },
                            hideExpression: (model) => {
                              if (model.lives_alone !== 'Yes') {
                                delete model.lives_in_nursing_home_facility;
                                return true;
                              }
                              return false;
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'employment_status',
                            templateOptions: {
                              label: 'Employment Status',
                              placeholder: ' ',
                              lookUpType: 'employment_status',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12 employment_status_other_txt',
                            type: 'getcare-input',
                            key: 'employment_status_other_txt',
                            templateOptions: {
                              label: ' ',
                              fieldClass: 'form-control form-control-lg'
                            },
                            hideExpression: (model) => {
                              if (model.employment_status !== 'Other') {
                                delete model.employment_status_other_txt;
                                return true;
                              }
                              return false;
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'veteran_status',
                            templateOptions: {
                              label: 'Veteran Status',
                              placeholder: ' ',
                              lookUpType: 'veteran_status',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-12',
                            type: 'getcare-select',
                            key: 'income_level',
                            templateOptions: {
                              label: 'Is the consumer\'s household income',
                              placeholder: ' ',
                              lookUpType: 'is_the_consumer_s_household_income',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-12 mt-2',
                            type: 'getcare-select',
                            key: 'has_case_manager',
                            templateOptions: {
                              label: 'Does the client have a Case Manager?',
                              placeholder: ' ',
                              lookUpType: 'yes_no_unkown',
                              fieldClass: 'form-control form-control-lg',
                              required: true
                            }
                          },
                          {
                            template: '<div class="font-weight-bold col-12">Benefits</div>'
                          },
                          {
                            key: 'benefits',
                            fieldGroupClassName: 'row',
                            className: 'col-12 mt-2',
                            fieldGroup: [
                              {
                                className: 'col-lg-2 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'medicaid',
                                templateOptions: {
                                  label: 'Medicaid'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-2 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'medicare',
                                templateOptions: {
                                  label: 'Medicare'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'publicly_subsidized_housing',
                                templateOptions: {
                                  label: 'Publicly - Subsidized Housing'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'disabled_benefits',
                                templateOptions: {
                                  label: 'Veterans\' Disabled Benefits'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'ssdi',
                                templateOptions: {
                                  label: 'Social Security Disability Insurance (SSDI)'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'ssi',
                                templateOptions: {
                                  label: 'Supplemental Security Income (SSI)'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'benefits_none',
                                templateOptions: {
                                  label: 'None'
                                },
                                expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  'templateOptions.disabled': 'model.medicaid || model.medicare || model.publicly_subsidized_housing || model.disabled_benefits || model.ssdi || model.ssi || model.ssrb || model.benefits_other'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'ssrb',
                                templateOptions: {
                                  label: 'Social Security Retirement Benefits'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-1 col-md-4 col-12',
                                type: 'getcare-checkbox',
                                key: 'benefits_other',
                                templateOptions: {
                                  label: 'Other'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.benefits_none'
                                }
                              },
                              {
                                className: 'col-lg-7 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'benefits_other_text',
                                templateOptions: {
                                  hideLabel: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': '!model.benefits_other',
                                  'model.benefits_other_text': 'field.templateOptions.disabled ? "" : model.benefits_other_text'
                                }
                              }
                            ]
                          },
                          {
                            template: '<div class="font-weight-bold col-12">Disabilities</div>'
                          },
                          {
                            key: 'disabilites',
                            fieldGroupClassName: 'row',
                            className: 'col-12 mt-2',
                            fieldGroup: [
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'physically_disabled',
                                templateOptions: {
                                  label: 'Physically Disabled'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'developmentally_disabled',
                                templateOptions: {
                                  label: 'Developmentally Disabled'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'hearing_difficulty',
                                templateOptions: {
                                  label: 'Hearing Difficulty'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'vision_difficulty',
                                templateOptions: {
                                  label: 'Vision Difficulty'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'self_care_difficulty',
                                templateOptions: {
                                  label: 'Self-care Difficulty'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'disabilities_none',
                                templateOptions: {
                                  label: 'None'
                                },
                                expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  'templateOptions.disabled': 'model.physically_disabled || model.developmentally_disabled || model.hearing_difficulty || model.vision_difficulty || model.independent_living_difficulty || model.disabilities_other'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-12 col-12',
                                type: 'getcare-checkbox',
                                key: 'independent_living_difficulty',
                                templateOptions: {
                                  label: 'Independent Living Difficulty'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-1 col-md-4 col-12',
                                type: 'getcare-checkbox',
                                key: 'disabilities_other',
                                templateOptions: {
                                  label: 'Other'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.disabilities_none'
                                }
                              },
                              {
                                className: 'col-lg-7 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'disabilities_other_text',
                                templateOptions: {
                                  hideLabel: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': '!model.disabilities_other',
                                  'model.disabilities_other_text': 'field.templateOptions.disabled ? "" : model.disabilities_other_text'
                                }
                              }
                            ]
                          },
                          {
                            template: '<div class="font-weight-bold col-12">Behavioral Health Screenings or Diagnoses</div>'
                          },
                          {
                            key: 'behavioral_health',
                            fieldGroupClassName: 'row',
                            className: 'col-12 mt-2',
                            fieldGroup: [
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'alcohol_use_disorder',
                                templateOptions: {
                                  label: 'Alcohol Use Disorder'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'anxiety',
                                templateOptions: {
                                  label: 'Anxiety'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'disorder',
                                templateOptions: {
                                  label: 'Bipolar Disorder'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'dementia',
                                templateOptions: {
                                  label: 'Dementia'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'depression',
                                templateOptions: {
                                  label: 'Depression'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'substance_use_disorder',
                                templateOptions: {
                                  label: 'Substance Use Disorder'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'traumatic_brain_injury',
                                templateOptions: {
                                  label: 'Traumatic Brain Injury'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-3 col-md-6 col-12',
                                type: 'getcare-checkbox',
                                key: 'behavioral_none',
                                templateOptions: {
                                  label: 'None'
                                },
                                expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  'templateOptions.disabled': 'model.alcohol_use_disorder || model.anxiety || model.disorder || model.dementia || model.depression || model.substance_use_disorder || model.traumatic_brain_injury || model.psychotic_disorders || model.behavioral_other'
                                }
                              },
                              {
                                className: 'col-lg-6 col-md-12 col-12',
                                type: 'getcare-checkbox',
                                key: 'psychotic_disorders',
                                templateOptions: {
                                  label: 'Schizophrenia and Other Psychotic Disorders'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.behavioral_none'
                                }
                              },
                              {
                                className: 'col-lg-1 col-md-4 col-12',
                                type: 'getcare-checkbox',
                                key: 'behavioral_other',
                                templateOptions: {
                                  label: 'Other'
                                }
                              },
                              {
                                className: 'col-lg-5 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'behavioral_other_text',
                                templateOptions: {
                                  hideLabel: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': '!model.behavioral_other',
                                  'model.behavioral_other_text': 'field.templateOptions.disabled ? "" : model.behavioral_other_text'
                                }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-select',
                        key: 'loss_of_housing_within_the_last_three_months',
                        templateOptions: {
                          label: 'Client has had a loss of housing within the last 3 months',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg',
                        }
                      },
                      {
                        type: 'getcare-radio',
                        key: 'loss_of_key_member_support_for_life_sustaining_activities',
                        templateOptions: {
                          // tslint:disable-next-line: max-line-length
                          label: 'Client has experienced a loss of key member support for life sustaining activities within 3 months of the date of the report.',
                          labelClass: 'col-lg-10 col-md-8 col-12',
                          valueClass: 'col-lg-2 col-md-4 col-12',
                          formCheck: 'inline',
                          inline: true,
                          lookUpType: 'yes_no'
                        },
                        className: 'col-12',
                      },
                      {
                        type: 'getcare-radio',
                        key: 'client_was_discharged_from_a_hospital_within_the_past_two_weeks',
                        templateOptions: {
                          // tslint:disable-next-line: max-line-length
                          label: 'Client was discharged from a hospital within the past two weeks from date of report and there are concerns due to lack of ability to follow through on their general care.',
                          labelClass: 'col-lg-10 col-md-8 col-12',
                          valueClass: 'col-lg-2 col-md-4 col-12',
                          formCheck: 'inline',
                          inline: true,
                          lookUpType: 'yes_no'
                        },
                        className: 'col-12',
                      },
                      {
                        type: 'getcare-radio',
                        key: 'client_presents_a_danger_to_themselves_or_others',
                        templateOptions: {
                          // tslint:disable-next-line: max-line-length
                          label: 'Is there reason to believe the client presents a danger to themselves or others?',
                          labelClass: 'col-lg-10 col-md-8 col-12',
                          valueClass: 'col-lg-2 col-md-4 col-12',
                          formCheck: 'inline',
                          inline: true,
                          lookUpType: 'yes_no'
                        },
                        className: 'col-12',
                      },
                    ]
                  },
                  {
                    id: 'functional_abilities',
                    key: 'functional_abilities',
                    wrappers: [
                      'getcare-panel'
                    ],
                    templateOptions: {
                      label: 'Functional Abilities',
                      open: true,
                      isDisabled: true
                    },
                    className: 'mt-1 col-12 px-2',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        template: '<div class="font-weight-bold col-12">ADL\'S</div>'
                      },
                      {
                        key: 'adl',
                        className: 'col-12 mt-2',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'eating_assistance_required',
                            templateOptions: {
                              label: 'Eating (feed self): Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'eating_available_supports',
                            templateOptions: {
                              label: 'Eating (feed self): Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'toileting_assistance_required',
                            templateOptions: {
                              label: 'Toileting: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'toileting_available_supports',
                            templateOptions: {
                              label: 'Toileting: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'walking_assistive_device_assistance_required',
                            templateOptions: {
                              label: 'Walking/Assistive Device: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'walking_assistive_device_available_supports',
                            templateOptions: {
                              label: 'Walking/Assistive Device: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'transfers_assistance_required',
                            templateOptions: {
                              label: 'Transfers: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'transfers_available_supports',
                            templateOptions: {
                              label: 'Transfers: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'dressing_undressing_assistance_required',
                            templateOptions: {
                              label: 'Dressing/Undressing: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'dressing_undressing_available_supports',
                            templateOptions: {
                              label: 'Dressing/Undressing: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'bathe_shower_assistance_required',
                            templateOptions: {
                              label: 'Bathe/Shower: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'adl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'bathe_shower_available_supports',
                            templateOptions: {
                              label: 'Bathe/Shower: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'adl'
                            }
                          }
                        ]
                      },
                      {
                        template: '<div class="font-weight-bold col-12">IADL\'S</div>'
                      },
                      {
                        key: 'iadl',
                        className: 'col-12 mt-2',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'prepare_meals_assistance_required',
                            templateOptions: {
                              label: 'Prepare Meals: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'prepare_meals_available_supports',
                            templateOptions: {
                              label: 'Prepare Meals: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'transportation_assistance_required',
                            templateOptions: {
                              label: 'Transportation: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'transportation_available_supports',
                            templateOptions: {
                              label: 'Transportation: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'manage_money_pay_bills_device_assistance_required',
                            templateOptions: {
                              label: 'Manage Money/Pay Bills: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'manage_money_pay_bills_available_supports',
                            templateOptions: {
                              label: 'Manage Money/Pay Bills: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'shop_for_food_personal_items_assistance_required',
                            templateOptions: {
                              label: 'Shop for Food/Personal Items: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'shop_for_food_personal_items_available_supports',
                            templateOptions: {
                              label: 'Shop for Food/Personal Items: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'laundry_assistance_required',
                            templateOptions: {
                              label: 'Laundry: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'laundry_available_supports',
                            templateOptions: {
                              label: 'Laundry: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'housekeeping_assistance_required',
                            templateOptions: {
                              label: 'Housekeeping: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'housekeeping_available_supports',
                            templateOptions: {
                              label: 'Housekeeping: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'medication_management_assistance_required',
                            templateOptions: {
                              label: 'Medication Management: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'medication_management_available_supports',
                            templateOptions: {
                              label: 'Medication Management: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'telephone_use_assistance_required',
                            templateOptions: {
                              label: 'Telephone Use: Assistance Required',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_assistance_required',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'iadl_need_total'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-12 col-12',
                            type: 'getcare-select',
                            key: 'telephone_use_available_supports',
                            templateOptions: {
                              label: 'Telephone Use: Available Supports',
                              placeholder: ' ',
                              lookUpType: 'adl_iadl_available_supports',
                              fieldClass: 'form-control form-control-lg',
                              scoringType: 'support_score',
                              supportScoreParent: 'iadl'
                            }
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-input',
                        key: 'adl_need_total',
                        defaultValue: '0',
                        templateOptions: {
                          label: 'ADL Need Total',
                          labelClass: 'col-lg-5 col-6 px-1 mt-2',
                          valueClass: 'col',
                          inline: true,
                          fieldClass: 'form-control form-control-lg border-0',
                          disabled: true
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-input',
                        key: 'iadl_need_total',
                        defaultValue: '0',
                        templateOptions: {
                          label: 'IADL Need Total',
                          labelClass: 'col-lg-5 col-6 px-1 mt-2',
                          valueClass: 'col',
                          inline: true,
                          fieldClass: 'form-control form-control-lg border-0',
                          disabled: true
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-input',
                        key: 'support_score',
                        defaultValue: '0',
                        templateOptions: {
                          label: 'Support Score',
                          labelClass: 'col-lg-5 col-6 px-1 mt-2',
                          valueClass: 'col',
                          inline: true,
                          fieldClass: 'form-control form-control-lg border-0',
                          disabled: true
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-input',
                        key: 'functional_abilities_score',
                        defaultValue: '0',
                        templateOptions: {
                          label: 'Functional Abilities Score',
                          labelClass: 'col-lg-5 col-6 px-1 mt-2',
                          valueClass: 'col',
                          inline: true,
                          fieldClass: 'form-control form-control-lg border-0',
                          disabled: true
                        }
                      }
                    ]
                  },
                  {
                    id: 'addition_info',
                    wrappers: [
                      'getcare-panel'
                    ],
                    templateOptions: {
                      label: '   ',
                      open: true,
                      isDisabled: true
                    },
                    className: 'mt-1 col-12 px-2',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'living_setting_at_start',
                        templateOptions: {
                          label: 'Living Setting at Start',
                          placeholder: ' ',
                          lookUpType: 'living_setting_at_start_and_at_close',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'living_setting_at_close',
                        templateOptions: {
                          label: 'Living Setting at Close',
                          placeholder: ' ',
                          lookUpType: 'living_setting_at_start_and_at_close',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'substitute_decision_makers_at_start',
                        templateOptions: {
                          label: 'Substitute Decision Makers at Start',
                          lookUpType: 'substitute_decision_makers_at_start_and_at_close',
                          multiple: true,
                          fieldClass: 'form-control form-control-lg',
                          attributes: {
                            size: '7'
                          }
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'substitute_decision_makers_at_close',
                        templateOptions: {
                          label: 'Substitute Decision Makers at Close',
                          lookUpType: 'substitute_decision_makers_at_start_and_at_close',
                          multiple: true,
                          fieldClass: 'form-control form-control-lg',
                          attributes: {
                            size: '7'
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  investigation: [
    {
      id: 'investigation',
      key: 'aps_report_load',
      wrappers: [
        'getcare-panel'
      ],
      templateOptions: {
        label: 'Investigation',
        open: true,
        isDisabled: true
      },
      className: 'col-12 mt-1',
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          id: 'alleged_perpetrator_information',
          key: 'abusers',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Alleged Perpetrator Information',
            open: true,
            isDisabled: true,
            isDisableSection: false
          },
          defaultValue: [
            {}
          ],
          expressionProperties: {
            'templateOptions.isDisableSection': (modelArray, modelObject, field) => {
              if ((field.parent.model.referral_criteria !== undefined
                  && field.parent.model.referral_criteria.alleged_maltreatment_self_neglect !== undefined
                  && field.parent.model.referral_criteria.alleged_maltreatment_self_neglect)
                  && !( (field.parent.model.referral_criteria.alleged_maltreatment_abuse !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_abuse)
                      || (field.parent.model.referral_criteria.alleged_maltreatment_neglect !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_neglect)
                      || (field.parent.model.referral_criteria.alleged_maltreatment_exploitation !== undefined && field.parent.model.referral_criteria.alleged_maltreatment_exploitation) )) {
                    return true;
              } else {
                return false;
              }
            }
          },
          className: 'mt-1 col-12',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove'
              },
              fieldArray: {
                className: 'border border-secondary p-4 col-12',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    template: '<div>Name of alleged Perpetrator</div>',
                    className: 'col-12 font-weight-bold'
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      placeholder: 'Last Name',
                      fieldClass: 'form-control form-control-lg',
                      disabled: false
                    },
                    expressionProperties: {
                      'templateOptions.disabled': 'model.unidentified_last_name'
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_last_name',
                    templateOptions: {
                      label: 'Unidentified',
                      change: (field, event) => {
                        if (field.formControl.value) {
                          field.parent.formControl.get('last_name').setValue('Unidentified');
                        } else {
                          field.parent.formControl.get('last_name').setValue('');
                        }
                      }
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12',
                    type: 'getcare-input',
                    key: 'first',
                    templateOptions: {
                      label: 'First Name',
                      placeholder: 'First Name',
                      fieldClass: 'form-control form-control-lg',
                      disabled: false
                    },
                    expressionProperties: {
                      'templateOptions.disabled': 'model.unidentified_first_name'
                    }
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12 smallFont',
                    type: 'getcare-checkbox',
                    key: 'unidentified_first_name',
                    templateOptions: {
                      label: 'Unidentified',
                      change: (field, event) => {
                        if (field.formControl.value) {
                          field.parent.formControl.get('first').setValue('Unidentified');
                        } else {
                          field.parent.formControl.get('first').setValue('');
                        }
                      }
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'other_name_info',
                    templateOptions: {
                      label: 'Provide any information to help identify the record:',
                      fieldClass: 'form-control form-control-lg',
                    },
                    hideExpression: '!(model.unidentified_first_name || model.unidentified_last_name)'
                  },
                  {
                    className: 'w-100'
                  },
                  {
                    className: 'col-lg-3 col-md-3 col-12 d-none',
                    type: 'getcare-input',
                    key: 'section_id',
                    templateOptions: {
                      type: 'hidden',
                      fieldClass: 'form-control form-control-lg',
                      hideLabel: true
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-select',
                    key: 'perpetrator_also_the_caregiver',
                    templateOptions: {
                      label: 'The alleged perpetrator is also the caregiver',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg',
                      change: field => {
                        const thisVal = field.parent.formControl.get('perpetrator_also_the_caregiver').value;
                        const fieldSectionId = field.parent.formControl.get('section_id').value;
                        if (thisVal === 'Yes') {
                          if (fieldSectionId === undefined || fieldSectionId === null || fieldSectionId === '') {
                            const abuserVal = field.form.root.value;
                            let idVal = 0;
                            const sectionIdLength = abuserVal.aps_report_load.abusers.undefined.filter(
                              data => {
                                if (data.section_id !== undefined && data.section_id !== null && data.section_id !== '') {
                                  return data;
                                }
                              }
                            );
                            if (sectionIdLength.length > 0) {
                              idVal = (sectionIdLength.length - 1) === 0 ? 1 : sectionIdLength.length + 1;
                            }
                            field.parent.formControl.get('section_id').setValue(`fg_${idVal}`);
                          }
                        }
                      }
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12 mt-2',
                    type: 'getcare-select',
                    key: 'kinship_relationship',
                    templateOptions: {
                      label: 'Kinship Relationship',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          placeholder: ' ',
                          hideLabel: true,
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg'
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-zip',
                        key: 'addrzip',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    template: '<div>Description:</div>',
                    className: 'col-12 font-weight-bold'
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'gender',
                    templateOptions: {
                      label: 'Gender',
                      placeholder: ' ',
                      lookUpType: 'gender',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'transgender',
                    templateOptions: {
                      label: 'Transgender',
                      placeholder: ' ',
                      lookUpType: 'yes_no',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-date',
                    key: 'dob',
                    templateOptions: {
                      label: 'DOB',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'age',
                    templateOptions: {
                      label: 'Age',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'race',
                    templateOptions: {
                      label: 'Race',
                      placeholder: ' ',
                      lookUpType: 'investigation_race',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'ethnicity',
                    templateOptions: {
                      label: 'Ethnicity',
                      placeholder: ' ',
                      lookUpType: 'abusers_ethnicity',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        template: '<div>Approx. Height</div>',
                        className: 'col-12 font-weight-bold mb-1'
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'height_feet',
                        templateOptions: {
                          label: 'Feet',
                          fieldClass: 'form-control form-control-lg',
                          inline: true,
                          labelClass: 'col-lg-5 col-md-6 col-12',
                          valueClass: 'col-lg-7 col-md-6 col-12'
                        },
                        wrappers: [
                          'getcare-form-field'
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'height_inches',
                        templateOptions: {
                          label: 'inches',
                          fieldClass: 'form-control form-control-lg',
                          inline: true,
                          labelClass: 'col-lg-5 col-md-6 col-12',
                          valueClass: 'col-lg-7 col-md-6 col-12'
                        },
                        wrappers: [
                          'getcare-form-field'
                        ]
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-12 col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        template: '<div>Approx. Weight</div>',
                        className: 'col-12 font-weight-bold mb-1'
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'weight',
                        templateOptions: {
                          hideLabel: true,
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'eyes',
                    templateOptions: {
                      label: 'Eyes',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'hair',
                    templateOptions: {
                      label: 'Hair',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'border border-secondary p-2 mt-2 row',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'combination_at_start',
                        templateOptions: {
                          label: 'Cohabitation at Start',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'combination_at_close',
                        templateOptions: {
                          label: 'Cohabitation at Close',
                          placeholder: ' ',
                          lookUpType: 'yes_no',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'perpetrator_association_at_start',
                        templateOptions: {
                          label: 'Perpetrator Association at Start',
                          placeholder: ' ',
                          lookUpType: 'caregiver_association_to_victim',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'perpetrator_association_at_close',
                        templateOptions: {
                          label: 'Perpetrator Association at Close',
                          placeholder: ' ',
                          lookUpType: 'caregiver_association_to_victim',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            template: '<div>Perpetrator Substitute Decision Maker at Start</div>',
                            className: 'col-12 font-weight-bold'
                          },
                          {
                            className: 'col-12 mt-3',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'representative_payee',
                                templateOptions: {
                                  label: 'Representative Payee'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship (non specific)'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'financial_proxy_in_Effect',
                                templateOptions: {
                                  label: 'Financial Proxy in Effect'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship_of_person',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Person'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'guardianship_or_conservatorship_of_property',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Property'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'health_care_proxy_in_Effect',
                                templateOptions: {
                                  label: 'Health Care Proxy in Effect'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'none',
                                templateOptions: {
                                  label: 'None'
                                },
                                expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  'templateOptions.disabled': 'model.representative_payee || model.guardianship_or_conservatorship || model.financial_proxy_in_Effect || model.guardianship_or_conservatorship_of_person || model.guardianship_or_conservatorship_of_property || model.health_care_proxy_in_Effect'
                                }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-12 col-12',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            template: '<div>Perpetrator Substitute Decision Maker at Close</div>',
                            className: 'col-12 font-weight-bold'
                          },
                          {
                            className: 'col-12 mt-3',
                            fieldGroupClassName: 'row',
                            fieldGroup: [
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_representative_payee',
                                templateOptions: {
                                  label: 'Representative Payee'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_guardianship_or_conservatorship',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship (non specific)'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_financial_proxy_in_effect',
                                templateOptions: {
                                  label: 'Financial Proxy in Effect'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_guardianship_or_conservatorship_of_person',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Person'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_guardian_or_conservatorship_of_property',
                                templateOptions: {
                                  label: 'Guardianship or Conservatorship of Property'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_health_care_proxy_in_effect',
                                templateOptions: {
                                  label: 'Health Care Proxy in Effect'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.psdmac_none'
                                }
                              },
                              {
                                className: 'col-12',
                                type: 'getcare-checkbox',
                                key: 'psdmac_none',
                                templateOptions: {
                                  label: 'None'
                                },
                                expressionProperties: {
                                  // tslint:disable-next-line: max-line-length
                                  'templateOptions.disabled': 'model.psdmac_representative_payee || model.psdmac_guardianship_or_conservatorship || model.psdmac_financial_proxy_in_effect || model.psdmac_guardianship_or_conservatorship_of_person || model.psdmac_guardian_or_conservatorship_of_property || model.psdmac_health_care_proxy_in_effect'
                                }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        className: 'col-12 my-2',
                        fieldGroupClassName: 'row',
                        hideExpression: (model, formState, field) => {
                          if (!(
                              (field.parent.model.address.address_type !== 'Work' && field.parent.model.address.address_type !== 'Business')
                              && (field.parent.model.perpetrator_association_at_start === 'Nursing home staff')
                              || field.parent.model.perpetrator_association_at_start === 'Residential care community staff'
                              || field.parent.model.perpetrator_association_at_start === 'Paid relative caregiver'
                              || field.parent.model.perpetrator_association_at_start === 'Unpaid relative caregiver'
                              || field.parent.model.perpetrator_association_at_start === 'Facility staff')) {
                                if (field.parent.form.get('employer_at_time_of_incident') !== null) {
                                  field.parent.form.get('employer_at_time_of_incident').setValue({
                                    address_type: '',
                                    unknown: false,
                                    addrlineone: '',
                                    addrlinetwo: '',
                                    addrcity: '',
                                    addrstate: '',
                                    addrzip: '',
                                    employer_telephone: ''
                                  });
                                }
                                return true;
                          }
                          return false;
                        },
                        fieldGroup: [
                          {
                            template: '<div>Perpetrator Employer at time of incident</div>',
                            className: 'col-12 font-weight-bold mb-2'
                          },
                          {
                            key: 'employer_at_time_of_incident',
                            className: 'col-12',
                            fieldGroupClassName: 'row no-gutter',
                            fieldGroup: [
                              {
                                className: 'col-lg-10 col-md-10 col-12',
                                type: 'getcare-input',
                                key: 'address_type',
                                templateOptions: {
                                  hideLabel: true,
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-lg-2 col-md-2 col-12',
                                type: 'getcare-checkbox',
                                key: 'unknown',
                                templateOptions: {
                                  label: 'Unknown',
                                  change: (field, event) => {
                                    if (field.formControl.value) {
                                      field.parent.formControl.get('address_type').setValue('');
                                      field.parent.formControl.get('addrlineone').setValue('');
                                      field.parent.formControl.get('addrlinetwo').setValue('');
                                      field.parent.formControl.get('addrcity').setValue('');
                                      field.parent.formControl.get('addrstate').setValue('');
                                      field.parent.formControl.get('addrzip').setValue('');
                                    }
                                  }
                                }
                              },
                              {
                                className: 'col-lg-6 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'addrlineone',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Address Line 1',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-lg-6 col-md-6 col-12',
                                type: 'getcare-input',
                                key: 'addrlinetwo',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Address Line 2',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-input',
                                key: 'addrcity',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'City',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-select',
                                key: 'addrstate',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: ' ',
                                  lookUpType: 'addrstate',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                defaultValue: 'ID',
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-lg-4 col-md-4 col-12',
                                type: 'getcare-zip',
                                key: 'addrzip',
                                templateOptions: {
                                  hideLabel: true,
                                  placeholder: 'Zip',
                                  fieldClass: 'form-control form-control-lg'
                                },
                                expressionProperties: {
                                  'templateOptions.disabled': 'model.unknown'
                                }
                              },
                              {
                                className: 'col-12',
                                fieldGroupClassName: 'row no-gutter',
                                fieldGroup: [
                                  {
                                    className: 'col-12',
                                    type: 'getcare-phone-number',
                                    key: 'employer_telephone',
                                    templateOptions: {
                                      label: 'Telephone',
                                      fieldClass: 'form-control form-control-lg'
                                    }
                                  }
                                ]
                              }
                            ]
                          },
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'allegation_disposition',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Allegation Disposition',
            open: true,
            isDisabled: true
          },
          className: 'mt-1 col-12',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              id: 'referral_criteria',
              key: 'referral_criteria',
              className: 'col-12',
              fieldGroupClassName: 'border border-secondary p-2 row',
              fieldGroup: [
                {
                  template: '<div class="font-weight-bold">Vulnerability and Maltreatment</div>',
                  className: 'col-12 mb-3'
                },
                {
                  // tslint:disable-next-line: max-line-length
                  template: '<div>Identify observations, credible information, and factual statements regarding the vulnerabilities<span class="text-danger ml-2">*</span></div>',
                  className: `col-lg-12 font-weight-bold ${fccOnly}`
                },
                {
                  className: 'ml-lg-3 col-lg-2 col-md-3 col-12',
                  type: 'getcare-checkbox',
                  key: 'vulnerability_mental',
                  templateOptions: {
                    label: 'Mental'
                  },
                  expressionProperties: {
                    'templateOptions.disabled': 'model.vulnerability_unknown'
                  }
                },
                {
                  className: 'col-lg-2 col-md-3 col-12',
                  type: 'getcare-checkbox',
                  key: 'vulnerability_physical',
                  templateOptions: {
                    label: 'Physical'
                  },
                  expressionProperties: {
                    'templateOptions.disabled': 'model.vulnerability_unknown'
                  }
                },
                {
                  className: 'col-lg-7 col-md-6 col-12',
                  type: 'getcare-checkbox',
                  key: 'vulnerability_unknown',
                  templateOptions: {
                    label: 'Vulnerability Unknown'
                  },
                  expressionProperties: {
                    'templateOptions.disabled': 'model.vulnerability_physical || model.vulnerability_mental'
                  }
                },
                {
                  className: 'col-12',
                  type: 'getcare-textarea',
                  key: 'mental_and_physical_vulnerability_comments',
                  templateOptions: {
                    hideLabel: true,
                    rows: 5,
                    fieldClass: 'form-control form-control-lg'
                  }
                },
                {
                  // tslint:disable-next-line: max-line-length
                  template: '<div>Identify observations, credible information, and factual statements regarding the maltreatment<span class="text-danger ml-2">*</span></div>',
                  className: `col-lg-12 font-weight-bold ${fccOnly}`
                },
                {
                  className: 'ml-lg-3 col-lg-1 col-md-2 col-12',
                  type: 'getcare-checkbox',
                  key: 'alleged_maltreatment_abuse',
                  templateOptions: {
                    label: 'Abuse'
                  }
                },
                {
                  className: 'col-lg-1 col-md-3 col-12',
                  type: 'getcare-checkbox',
                  key: 'alleged_maltreatment_neglect',
                  templateOptions: {
                    label: 'Neglect'
                  }
                },
                {
                  className: 'col-lg-2 col-md-3 col-12 mx-lg-2',
                  type: 'getcare-checkbox',
                  key: 'alleged_maltreatment_exploitation',
                  templateOptions: {
                    label: 'Exploitation'
                  }
                },
                {
                  className: 'col-lg-5 col-md-4 col-12',
                  type: 'getcare-checkbox',
                  key: 'alleged_maltreatment_self_neglect',
                  templateOptions: {
                    label: 'Self-Neglect'
                  }
                },
                {
                  className: 'col-12',
                  type: 'getcare-textarea',
                  key: 'abuse_neglect_exploitation_comments',
                  templateOptions: {
                    hideLabel: true,
                    rows: 5,
                    fieldClass: 'form-control form-control-lg'
                  }
                },
                {
                  className: 'col-lg-6 col-md-12 col-12',
                  type: 'getcare-select',
                  key: 'at_start_still_have_access_to_the_victim',
                  templateOptions: {
                    label: 'At start does the alleged perpetrator still have access to the victim?',
                    placeholder: ' ',
                    lookUpType: 'yes_no_unkown',
                    fieldClass: 'form-control form-control-lg'
                  }
                },
                {
                  className: 'col-lg-6 col-md-12 col-12',
                  type: 'getcare-select',
                  key: 'at_close_still_have_access_to_the_victim',
                  templateOptions: {
                    label: 'At close does the alleged perpetrator still have access to the victim?',
                    placeholder: ' ',
                    lookUpType: 'yes_no_unkown',
                    fieldClass: 'form-control form-control-lg'
                  }
                }
              ]
            },
            {
              id: 'incident_addresses',
              key: 'incident_addresses',
              className: 'col-12 mt-2',
              fieldGroupClassName: 'border border-secondary p-2 row',
              defaultValue: [
                {}
              ],
              fieldGroup: [
                {
                  type: 'getcare-repeat-component',
                  className: 'col-12 mb-2 mt-2',
                  templateOptions: {
                    hideAddTextLabel: true,
                    hideRemoveTextLabel: true
                  },
                  fieldArray: {
                    fieldGroupClassName: 'mb-2 row',
                    fieldGroup: [
                      {
                        template: '<div class="font-weight-bold">Incident Information</div>',
                        className: 'col-12 mb-3'
                      },
                      {
                        className: `col-lg-6 col-md-6 col-12 ${fccOnly}`,
                        type: 'getcare-select',
                        key: 'maltreatment_setting',
                        templateOptions: {
                          label: 'Maltreatment Setting',
                          placeholder: ' ',
                          lookUpType: 'maltreatment_setting',
                          required: true,
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'place_of_incident',
                        templateOptions: {
                          label: 'Place of incident',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        key: 'address_incident_occurred',
                        fieldGroupClassName: 'mb-2 row',
                        fieldGroup: [
                          {
                            className: 'col-lg-6 col-md-6 col-12 mt-2',
                            type: 'getcare-select',
                            key: 'address_type',
                            templateOptions: {
                              label: 'Address where incident occurred',
                              placeholder: ' ',
                              lookUpType: 'work_home_mailing_address_temporary_business',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-6 col-12 mt-2',
                            type: 'getcare-select',
                            key: 'county',
                            templateOptions: {
                              label: 'County',
                              placeholder: ' ',
                              lookUpType: 'county',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-6 col-12',
                            type: 'getcare-input',
                            key: 'addrlineone',
                            templateOptions: {
                              hideLabel: true,
                              placeholder: 'Address Line 1',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-6 col-md-6 col-12',
                            type: 'getcare-input',
                            key: 'addrlinetwo',
                            templateOptions: {
                              hideLabel: true,
                              placeholder: 'Address Line 2',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-input',
                            key: 'addrcity',
                            templateOptions: {
                              hideLabel: true,
                              placeholder: 'City',
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-select',
                            key: 'addrstate',
                            templateOptions: {
                              hideLabel: true,
                              placeholder: ' ',
                              lookUpType: 'addrstate',
                              fieldClass: 'form-control form-control-lg'
                            },
                            defaultValue: 'ID'
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-zip',
                            key: 'addrzip',
                            templateOptions: {
                              hideLabel: true,
                              placeholder: 'Zip',
                              fieldClass: 'form-control form-control-lg'
                            }
                          }
                        ]
                      },
                      {
                        className: 'col-lg-4 col-md-12 col-12',
                        type: 'getcare-select',
                        key: 'occurrence',
                        templateOptions: {
                          label: 'The occurrence is',
                          placeholder: ' ',
                          lookUpType: 'occurrence',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'date',
                        templateOptions: {
                          label: 'Date',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'time',
                        templateOptions: {
                          label: 'Time',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-checkbox',
                        key: 'supplemental_info_attached',
                        templateOptions: {
                          label: 'Check if medical, financial, photographers, or other supplemental information is attached.'
                        }
                      }
                    ]
                  }
                }
              ]
            },
            {
              id: 'perpetration_abuse_result',
              key: 'perpetration_abuse_result',
              className: 'col-12 mt-2',
              fieldGroupClassName: 'border border-secondary p-2 row',
              defaultValue: [
                {}
              ],
              fieldGroup: [
                {
                  type: 'getcare-repeat-component',
                  className: 'col-12 mb-2 mt-2',
                  templateOptions: {
                    addTextLabel: '<i class="fa fa-plus"></i>',
                    removeTextLabel: '<i class="fa fa-minus"></i>'
                  },
                  fieldArray: {
                    fieldGroupClassName: 'mb-2 row',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-select',
                        key: 'type_of_maltreatment',
                        templateOptions: {
                          label: 'Type of Maltreatment',
                          placeholder: ' ',
                          lookUpType: 'investigation_type_of_maltreatment',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        template: '<div>Maltreatment resulted in:</div>',
                        className: 'col-12 font-weight-bold'
                      },
                      {
                        className: 'col-12 mt-2',
                        fieldGroupClassName: 'row',
                        fieldGroup: [
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'physical_injury',
                            templateOptions: {
                              label: 'Physical Injury'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'minor_medical_care',
                            templateOptions: {
                              label: 'Minor Medical Care'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'hospitalization',
                            templateOptions: {
                              label: 'Hospitalization'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'care_provider_required',
                            templateOptions: {
                              label: 'Care Provider Required'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'death',
                            templateOptions: {
                              label: 'Death'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'mental_suffering',
                            templateOptions: {
                              label: 'Mental Suffering'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'unknown',
                            templateOptions: {
                              label: 'Unknown'
                            },
                            expressionProperties: {
                              // tslint:disable-next-line: max-line-length
                              'templateOptions.disabled': 'model.not_applicable || model.physical_injury || model.minor_medical_care || model.hospitalization || model.care_provider_required || model.death || model.mental_suffering || model.other'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'other',
                            templateOptions: {
                              label: 'Other (Specify)'
                            },
                            expressionProperties: {
                              'templateOptions.disabled': 'model.unknown || model.not_applicable'
                            }
                          },
                          {
                            className: 'col-lg-4 col-md-4 col-12',
                            type: 'getcare-checkbox',
                            key: 'not_applicable',
                            templateOptions: {
                              label: 'Not Applicable'
                            },
                            expressionProperties: {
                              // tslint:disable-next-line: max-line-length
                              'templateOptions.disabled': 'model.unknown || model.physical_injury || model.minor_medical_care || model.hospitalization || model.care_provider_required || model.death || model.mental_suffering || model.other'
                            }
                          }
                        ]
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-textarea',
                        key: 'other_maltreatment_result',
                        templateOptions: {
                          hideLabel: true,
                          rows: 5,
                          fieldClass: 'form-control form-control-lg'
                        },
                        hideExpression: '!model.other',
                        expressionProperties: {
                          'model.other_maltreatment_result': '!model.other ? "" : model.other_maltreatment_result'
                        }
                      },

                      {
                        type: 'getcare-repeat-component',
                        className: 'col-12',
                        key: 'financial_accounts',
                        templateOptions: {
                          addTextLabel: '<i class="fa fa-plus"></i> Add',
                          removeTextLabel: '<i class="fa fa-trash"></i> Remove'
                        },
                        hideExpression: (model, formState, field) => {
                          return field.parent.formControl.get('type_of_maltreatment').value !== "Financial exploitation";
                        },
                        defaultValue: [{}],
                        fieldArray: {
                          className: 'col-12',
                          fieldGroupClassName: 'mb-2 row',
                          fieldGroup: [
                            {
                              type: 'getcare-input',
                              key: 'account_number_last_four_digits',
                              templateOptions: {
                                label: 'Account Number (last 4 digits):',
                                labelClass: 'col-lg-8 col-12',
                                valueClass: 'col-lg-4 col-12',
                                inline: true,
                                type: 'ssnLastType'
                              },
                              className: 'col-lg-6 col-12',
                              wrappers: [
                                'getcare-form-field'
                              ]
                            },
                            {
                              type: 'getcare-input',
                              key: 'type_of_account',
                              templateOptions: {
                                label: 'Type of account',
                                labelClass: 'col-lg-5 col-12',
                                valueClass: 'col-lg-7 col-12',
                                inline: true,
                              },
                              className: 'col-lg-6 col-12',
                              wrappers: [
                                'getcare-form-field'
                              ]
                            },
                            {
                              className: 'col-lg-6 col-12',
                              type: 'getcare-select',
                              key: 'trust_account',
                              templateOptions: {
                                label: 'Trust account:',
                                placeholder: ' ',
                                lookUpType: 'yes_no',
                                fieldClass: 'form-control form-control-lg',
                              }
                            },
                            {
                              className: 'col-lg-6 col-12',
                              type: 'getcare-select',
                              key: 'power_of_attorney',
                              templateOptions: {
                                label: 'Power of attorney:',
                                placeholder: ' ',
                                lookUpType: 'yes_no',
                                fieldClass: 'form-control form-control-lg',
                              }
                            },
                            {
                              className: 'col-lg-6 col-12',
                              type: 'getcare-select',
                              key: 'direct_deposit',
                              templateOptions: {
                                label: 'Direct Deposit:',
                                placeholder: ' ',
                                lookUpType: 'yes_no',
                                fieldClass: 'form-control form-control-lg',
                              }
                            },
                            {
                              className: 'col-lg-6 col-12',
                              type: 'getcare-select',
                              key: 'other_accounts',
                              templateOptions: {
                                label: 'Other accounts:',
                                placeholder: ' ',
                                lookUpType: 'yes_no',
                                fieldClass: 'form-control form-control-lg',
                              }
                            },
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          id: 'caregiver_information',
          key: 'caregivers',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Caregiver Information-Person responsible for the client\'s medical or financial care',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-button',
              className: 'col-12',
              templateOptions: {
                text: 'Sync with Alleged Perpetrator Information',
                type: 'getcare-button',
                btnType: 'primary',
                fieldClass: 'float-right btn-block',
                functionString: 'sync',
                disabled: true
              },
              expressionProperties: {
                'templateOptions.disabled': (modelArray, modelObject, field) => {
                  if (field.parent.parent.model.abusers !== undefined && field.parent.parent.model.abusers.length > 0) {
                    const hasSyncData = field.parent.parent.model.abusers.filter(
                      fdata => {
                        if ((fdata.perpetrator_also_the_caregiver !== undefined
                            && fdata.perpetrator_also_the_caregiver !== null) && (fdata.perpetrator_also_the_caregiver === 'Yes')) {
                              return fdata;
                        }
                      }
                    );
                    if (hasSyncData.length > 0) {
                      return false;
                    }
                  }
                  return true;
                }
              },
            },
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove'
              },
              fieldArray: {
                className: 'border border-secondary p-4 col-12',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row',
                    fieldGroup: [
                      {
                        className: 'col-lg-3 col-md-6 col-12 order-lg-1 order-md-2 mt-md-2 mt-lg-0',
                        type: 'getcare-input',
                        key: 'last_name',
                        templateOptions: {
                          label: 'Last Name',
                          placeholder: 'Last Name',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.model.section_id !== undefined && field.model.section_id !== null && field.model.section_id !== '') {
                              if (field.options.formState.disableSectionG !== undefined
                                  && field.options.formState.disableSectionG.includes(field.model.section_id)) {
                                  return true;
                              }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-3 col-md-6 col-12 order-lg-2 order-md-3 mt-md-2 mt-lg-0',
                        type: 'getcare-input',
                        key: 'first_name',
                        templateOptions: {
                          label: 'First Name',
                          placeholder: 'First Name',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.model.section_id !== undefined && field.model.section_id !== null && field.model.section_id !== '') {
                              if (field.options.formState.disableSectionG !== undefined
                                  && field.options.formState.disableSectionG.includes(field.model.section_id)) {
                                  return true;
                              }
                            }
                            return false;
                          }
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'kinship_relationship_to_victim',
                    templateOptions: {
                      label: 'Kinship Relationship to victim',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg',
                      disabled: false
                    },
                    expressionProperties: {
                      'templateOptions.disabled': (modelArray, modelObject, field) => {
                        if (field.model.section_id !== undefined && field.model.section_id !== null && field.model.section_id !== '') {
                          if (field.options.formState.disableSectionG !== undefined
                              && field.options.formState.disableSectionG.includes(field.model.section_id)) {
                              return true;
                          }
                        }
                        return false;
                      }
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-select',
                    key: 'caregiver_association_to_victim',
                    templateOptions: {
                      label: 'Caregiver Association to victim',
                      placeholder: ' ',
                      lookUpType: 'caregiver_association_to_victim',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: ' ',
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        defaultValue: 'ID',
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-zip',
                        key: 'addrzip',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.parent.parent.model.section_id !== undefined && field.parent.parent.model.section_id !== null
                                && field.parent.parent.model.section_id !== '') {
                                if (field.options.formState.disableSectionG !== undefined
                                    && field.options.formState.disableSectionG.includes(field.parent.parent.model.section_id)) {
                                    return true;
                                }
                            }
                            return false;
                          }
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.model.section_id !== undefined && field.model.section_id !== null && field.model.section_id !== '') {
                              if (field.options.formState.disableSectionG !== undefined
                                  && field.options.formState.disableSectionG.includes(field.model.section_id)) {
                                  return true;
                              }
                            }
                            return false;
                          }
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg',
                          disabled: false
                        },
                        expressionProperties: {
                          'templateOptions.disabled': (modelArray, modelObject, field) => {
                            if (field.model.section_id !== undefined && field.model.section_id !== null && field.model.section_id !== '') {
                              if (field.options.formState.disableSectionG !== undefined
                                  && field.options.formState.disableSectionG.includes(field.model.section_id)) {
                                  return true;
                              }
                            }
                            return false;
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'witness_or_other_person',
          key: 'witnesses',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Witness or Other person believed to have knowledge of Maltreatment',
            open: true,
            isDisabled: true
          },
          defaultValue: [
            {}
          ],
          className: 'mt-1 col-12',
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              type: 'getcare-repeat-component',
              className: 'col-12 mb-2 mt-2',
              templateOptions: {
                addTextLabel: 'Add an additional record',
                removeTextLabel: 'Remove'
              },
              fieldArray: {
                className: 'border border-secondary p-4 col-12',
                fieldGroupClassName: 'mb-2 row',
                fieldGroup: [
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'last_name',
                    templateOptions: {
                      label: 'Last Name',
                      placeholder: 'Last Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-lg-6 col-md-6 col-12',
                    type: 'getcare-input',
                    key: 'first_name',
                    templateOptions: {
                      label: 'First Name',
                      placeholder: 'First Name',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    className: 'col-12',
                    type: 'getcare-select',
                    key: 'kinship_relationship_to_victim',
                    templateOptions: {
                      label: 'Kinship Relationship to victim',
                      placeholder: ' ',
                      lookUpType: 'kinship_relationship',
                      fieldClass: 'form-control form-control-lg'
                    }
                  },
                  {
                    key: 'address',
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'address_type',
                        templateOptions: {
                          label: 'Address where incident occurred',
                          placeholder: ' ',
                          lookUpType: 'work_home_mailing_address_temporary_business',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-select',
                        key: 'county',
                        templateOptions: {
                          label: 'County',
                          placeholder: ' ',
                          lookUpType: 'county',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlineone',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 1',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        type: 'getcare-input',
                        key: 'addrlinetwo',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Address Line 2',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-input',
                        key: 'addrcity',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'City',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-select',
                        key: 'addrstate',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: ' ',
                          lookUpType: 'addrstate',
                          fieldClass: 'form-control form-control-lg'
                        },
                        defaultValue: 'ID'
                      },
                      {
                        className: 'col-lg-4 col-md-4 col-12',
                        type: 'getcare-zip',
                        key: 'addrzip',
                        templateOptions: {
                          hideLabel: true,
                          placeholder: 'Zip',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-12',
                    fieldGroupClassName: 'row no-gutter',
                    fieldGroup: [
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'telephone',
                        templateOptions: {
                          label: 'Telephone',
                          fieldClass: 'form-control form-control-lg'
                        }
                      },
                      {
                        className: 'col-12',
                        type: 'getcare-input',
                        key: 'email',
                        templateOptions: {
                          label: 'Email',
                          fieldClass: 'form-control form-control-lg'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        {
          id: 'services_or_referrals_made',
          key: 'services_or_referrals_made',
          className: 'mt-1 col-12',
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: 'Services/Referrals Made',
            open: true,
            isDisabled: true
          },
          fieldGroupClassName: 'row p-lg-3 p-md-3 p-0',
          fieldGroup: [
            {
              template: 'At least 1 service/referral needs to be selected for columns 1, 2, 3, 4.'
            },
            {
              id: '05edc6ba-0c0a-410a-9a66-38342ac980f6',
              className: 'col-12 transparentBg',
              fieldGroupClassName: 'row',
              wrappers: [
                'getcare-panel'
              ],
              templateOptions: {
                label: 'NAMRS Definitions',
                open: false,
                disabled: null,
                hideLabel: false
              },
              fieldGroup: [
                {
                  // tslint:disable-next-line: max-line-length
                  template: '<div class="table-responsive"><table class="table table-bordered">    <thead>      <tr class="font-weight-bold">        <th>Value</th>        <th>Value Definition</th>      </tr>    </thead>    <tbody>      <tr>        <td>Care Planning Service</td>        <td>Development and implementation of a service plan to mobilize the formal and informal resources and services identified in the assessment to meet the needs of the client. Includes the development and oversight of a plan to ensure the safety and well-being of the client; developing a safety plan with a person’s support network; referring and arranging support services, etc.</td>      </tr>      <tr>        <td>Caregiver support services</td>        <td>Assistance to family and other informal caregivers to improve or sustain capacity for caring for the older adult or adult with disabilities. Includes counseling, support groups, training, respite, etc.</td>      </tr>      <tr>        <td>Community day services</td>        <td>Services or activities provided to adults who require care and supervision in a protective setting for a portion of a 24-hour day. Includes out of home supervision, health care, recreation, and/or independent living skills training offered in centers most commonly known as Adult Day, Adult Day Health, Senior Centers, and Disability Day Programs.</td>      </tr>      <tr>        <td>Education, employment, and training services</td>        <td>Services and activities to assist people in achieving or maintaining economic self-support. Includes training programs, job coaches, supported employment, senior employment programs, and public school individualized education plans.</td>      </tr>      <tr>        <td>Emergency assistance and material aid services</td>        <td>Providing, arranging for, or facilitating the provision of medical, social service, economic, emergency, or support services. Includes financial assistance or referral for food, clothing, energy/utility assistance, and home repairs/modifications; environmental clean-up of client’s home including but not limited to removal of trash, extermination services and cleaning; relocation assistance; urgent medical expenses not typically covered by insurance (eye glasses, dentures); emergency housing/shelter; etc.</td>      </tr>      <tr>        <td>Financial planning services</td>        <td>Services or activities to assist in managing finances or planning for future financial needs. Includes meeting with bank officials, financial planning, estate planning, money management, and retirement income planning.</td>      </tr>      <tr>        <td>Housing and relocation services</td>        <td>Services or activities designed to assist in the obtaining of suitable or safe housing and living arrangements. Includes tenant counseling; helping to identify and correct substandard housing conditions; making moving arrangements and minor renovations to personal residence; and relocating to institutional care or facility care.</td>      </tr>      <tr>        <td>In-home assistance services</td>        <td>Services or activities provided to clients to achieve or maintain self- sufficiency. Includes homemakers and home health aides; visiting and telephone reassurance; chore maintenance; personal care services, etc.</td>      </tr>      <tr>        <td>Legal services</td>        <td>Legal counsel and representation provided by an attorney to address civil matters such as housing issues and advance care planning, and criminal matters.</td>      </tr>      <tr>        <td>Medical and dental services</td>        <td>Services and activities designed to assist individuals and families to attain and maintain a favorable condition of health; includes evaluations.</td>      </tr>      <tr>        <td>Medical rehabilitation services</td>        <td>Services and activities for persons with developmental or physical disabilities, or persons with visual or auditory impairments, are services or activities to maximize the potential of persons with disabilities, help alleviate the effects of physical, mental or emotional disabilities, and to enable these persons to live in the least restrictive environment possible. Includes training in mobility, communication skills, the use of special aids and appliances, self-sufficiency skills for people with disabilities, occupational therapy, physical therapy, speech and language pathology, early intervention and other therapies that help people learn the skills they need to live, learn, work and play in their communities.</td>      </tr>      <tr>        <td>Mental health services</td>        <td>Services and activities, including commitment, assessment, and evaluations, for people with behavioral health conditions characterized by dysregulation of mood, thought, and/or behavior, as recognized by the DSM-5. Includes services and activities that apply therapeutic processes to personal, family, situational, or occupational problems in order to bring about a positive resolution of the problem or improved individual or family functioning or circumstances.</td>      </tr>      <tr>        <td>Nutrition</td>        <td>Services and activities, including appeals and applications, to provide food to a client lacking recommended daily nutritional requirements and/or Activities of Daily Living (ADL) limitations. Includes home delivered meals, nutritional counseling, congregate meals, senior farmers’ market program, etc.</td>      </tr>      <tr>        <td>Public assistance benefits</td>        <td>Services and assistance to provide a safety net for disadvantaged individuals who lack the resources to provide basic necessities for themselves and their families. Includes such programs as financial aid (TANF), nutrition (SNAP), energy assistance (LIHEAP), health care (Medicaid), etc.</td>      </tr>      <tr>        <td>Substance use services</td>        <td>"Services and activities primarily designed to deter, reduce, or eliminate substance abuse or chemical dependence. Includes a comprehensive range of personal and family counseling methods, methadone treatment for opiate abusers, or detoxification treatment for alcohol abusers. Services and activities may be provided in alternative living arrangements such as institutional settings and community-based halfway houses."</td>      </tr>      <tr>        <td>Transportation</td>        <td>"Services or activities that provide or arrange for the travel, including travel costs, of individuals in order to access services, or obtain medical care or employment."</td>      </tr>      <tr>        <td>Victim services</td>        <td>Services and activities provided to, or on behalf of, victims at any stage of the criminal justice process, including post sentencing services and support. Includes programs supporting victims of domestic violence, sexual assault, abuse of older women, violence against women, and general crimes which are being handled by the police or prosecutors’ offices.</td>      </tr>      <tr>        <td>Other services</td>        <td>Client receives services and activities not included in the categorizations provided.</td>      </tr>      <tr>        <td>None</td>        <td>Client receives or was referred to no services.</td>      </tr>    </tbody></table></div>',
                  className: 'col-12'
                }
              ],
              type: 'formly-group'
            },
            {
              className: 'col-12 mt-2',
              fieldGroupClassName: 'border border-secondary p-2 row',
              fieldGroup: [
                {
                  className: 'col-lg-3 col-md-6 col-12',
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      // tslint:disable-next-line: max-line-length
                      template: '<div class="col-12"><b>Services at Start</b><span class="text-danger font-weight-bold ml-2">*</span></div>',
                      className: `col-12 ${fccOnly}`
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_care_planning_services',
                      templateOptions: {
                        label: 'Care Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_caregiver_support_services',
                      templateOptions: {
                        label: 'Caregiver Support Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_community_day_services',
                      templateOptions: {
                        label: 'Community Day Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_education_employment_training_services',
                      templateOptions: {
                        label: 'Education, Employment, and Training Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_emergency_assistance_and_material_aid_services',
                      templateOptions: {
                        label: 'Emergency Assistance and Material Aid Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_financial_planning_services',
                      templateOptions: {
                        label: 'Financial Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_housing_and_relocation_services',
                      templateOptions: {
                        label: 'Housing and Relocation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_in_home_assistance_services',
                      templateOptions: {
                        label: 'In-home Assistance Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_legal_services',
                      templateOptions: {
                        label: 'Legal Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_medical_and_dental_services',
                      templateOptions: {
                        label: 'Medical and Dental Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_medical_rehabilitation_services',
                      templateOptions: {
                        label: 'Medical Rehabilitation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_mental_health_services',
                      templateOptions: {
                        label: 'Mental Health Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_nutrition',
                      templateOptions: {
                        label: 'Nutrition'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_public_assistance_benefits',
                      templateOptions: {
                        label: 'Public Assistance Benefits'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_substance_use_services',
                      templateOptions: {
                        label: 'Substance Use Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_transportation',
                      templateOptions: {
                        label: 'Transportation'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_victim_services',
                      templateOptions: {
                        label: 'Victim Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_other_services',
                      templateOptions: {
                        label: 'Other Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sas_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sas_none',
                      templateOptions: {
                        label: 'None'
                      },
                      expressionProperties: {
                        // tslint:disable-next-line: max-line-length
                        'templateOptions.disabled': 'model.sas_care_planning_services || model.sas_caregiver_support_services || model.sas_community_day_services || model.sas_legal_services || model.sas_emergency_assistance_and_material_aid_services || model.sas_financial_planning_services || model.sas_housing_and_relocation_services || model.sas_in_home_assistance_services || model.sas_education_employment_training_services || model.sas_medical_and_dental_services || model.sas_medical_rehabilitation_services || model.sas_mental_health_services || model.sas_nutrition || model.sas_public_assistance_benefits || model.sas_substance_use_services || model.sas_transportation || model.sas_victim_services || model.sas_other_services'
                      }
                    }
                  ]
                },
                {
                  className: 'col-lg-3 col-md-6 col-12',
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      // tslint:disable-next-line: max-line-length
                      template: '<div class="col-12"><b>Services APS Provided During Investigation</b><span class="text-danger font-weight-bold ml-2">*</span></div>',
                      className: `col-12 ${fccOnly}`
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_care_planning_services',
                      templateOptions: {
                        label: 'Care Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sapdi_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_caregiver_support_services',
                      templateOptions: {
                        label: 'Caregiver Support Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sapdi_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_emergency_assistance_and_material_aid_services',
                      templateOptions: {
                        label: 'Emergency Assistance and Material Aid Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sapdi_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_housing_and_relocation_services',
                      templateOptions: {
                        label: 'Housing and Relocation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sapdi_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_transportation',
                      templateOptions: {
                        label: 'Transportation'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sapdi_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sapdi_none',
                      templateOptions: {
                        label: 'None'
                      },
                      expressionProperties: {
                        // tslint:disable-next-line: max-line-length
                        'templateOptions.disabled': 'model.sapdi_care_planning_services || model.sapdi_caregiver_support_services || model.sapdi_emergency_assistance_and_material_aid_services || model.sapdi_housing_and_relocation_services || model.sapdi_transportation'
                      }
                    }
                  ]
                },
                {
                  className: 'col-lg-3 col-md-6 col-12',
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      // tslint:disable-next-line: max-line-length
                      template: '<div class="col-12"><b>Services Referred by APS</b><span class="text-danger font-weight-bold ml-2">*</span></div>',
                      className: `col-12 ${fccOnly}`
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_care_planning_services',
                      templateOptions: {
                        label: 'Care Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_caregiver_support_services',
                      templateOptions: {
                        label: 'Caregiver Support Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_community_day_services',
                      templateOptions: {
                        label: 'Community Day Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_education_employment_training_services',
                      templateOptions: {
                        label: 'Education, Employment, and Training Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_emergency_assistance_and_material_aid_services',
                      templateOptions: {
                        label: 'Emergency Assistance and Material Aid Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_financial_planning_services',
                      templateOptions: {
                        label: 'Financial Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_housing_and_relocation_services',
                      templateOptions: {
                        label: 'Housing and Relocation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_in_home_assistance_services',
                      templateOptions: {
                        label: 'In-home Assistance Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_legal_services',
                      templateOptions: {
                        label: 'Legal Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_medical_and_dental_services',
                      templateOptions: {
                        label: 'Medical and Dental Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_medical_rehabilitation_services',
                      templateOptions: {
                        label: 'Medical Rehabilitation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_mental_health_services',
                      templateOptions: {
                        label: 'Mental Health Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_nutrition',
                      templateOptions: {
                        label: 'Nutrition'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_public_assistance_benefits',
                      templateOptions: {
                        label: 'Public Assistance Benefits'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_substance_use_services',
                      templateOptions: {
                        label: 'Substance Use Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_transportation',
                      templateOptions: {
                        label: 'Transportation'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_victim_services',
                      templateOptions: {
                        label: 'Victim Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_other_services',
                      templateOptions: {
                        label: 'Other Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.srba_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'srba_none',
                      templateOptions: {
                        label: 'None'
                      },
                      expressionProperties: {
                        // tslint:disable-next-line: max-line-length
                        'templateOptions.disabled': 'model.srba_care_planning_services || model.srba_caregiver_support_services || model.srba_community_day_services || model.srba_legal_services || model.srba_emergency_assistance_and_material_aid_services || model.srba_financial_planning_services || model.srba_housing_and_relocation_services || model.srba_in_home_assistance_services || model.srba_education_employment_training_services || model.srba_medical_and_dental_services || model.srba_medical_rehabilitation_services || model.srba_mental_health_services || model.srba_nutrition || model.srba_public_assistance_benefits || model.srba_substance_use_services || model.srba_transportation || model.srba_victim_services || model.srba_other_services'
                      }
                    }
                  ]
                },
                {
                  className: 'col-lg-3 col-md-6 col-12',
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      // tslint:disable-next-line: max-line-length
                      template: '<div class="col-12"><b>Services at Close</b><span class="text-danger font-weight-bold ml-2">*</span></div>',
                      className: `col-12 ${fccOnly}`
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_care_planning_services',
                      templateOptions: {
                        label: 'Care Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_caregiver_support_services',
                      templateOptions: {
                        label: 'Caregiver Support Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_community_day_services',
                      templateOptions: {
                        label: 'Community Day Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_education_employment_training_services',
                      templateOptions: {
                        label: 'Education, Employment, and Training Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_emergency_assistance_and_material_aid_services',
                      templateOptions: {
                        label: 'Emergency Assistance and Material Aid Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_financial_planning_services',
                      templateOptions: {
                        label: 'Financial Planning Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_housing_and_relocation_services',
                      templateOptions: {
                        label: 'Housing and Relocation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_in_home_assistance_services',
                      templateOptions: {
                        label: 'In-home Assistance Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_legal_services',
                      templateOptions: {
                        label: 'Legal Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_medical_and_dental_services',
                      templateOptions: {
                        label: 'Medical and Dental Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_medical_rehabilitation_services',
                      templateOptions: {
                        label: 'Medical Rehabilitation Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_mental_health_services',
                      templateOptions: {
                        label: 'Mental Health Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_nutrition',
                      templateOptions: {
                        label: 'Nutrition'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_public_assistance_benefits',
                      templateOptions: {
                        label: 'Public Assistance Benefits'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_substance_use_services',
                      templateOptions: {
                        label: 'Substance Use Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_transportation',
                      templateOptions: {
                        label: 'Transportation'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_victim_services',
                      templateOptions: {
                        label: 'Victim Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_other_services',
                      templateOptions: {
                        label: 'Other Services'
                      },
                      expressionProperties: {
                        'templateOptions.disabled': 'model.sac_none'
                      }
                    },
                    {
                      className: 'col-12',
                      type: 'getcare-checkbox',
                      key: 'sac_none',
                      templateOptions: {
                        label: 'None'
                      },
                      expressionProperties: {
                        // tslint:disable-next-line: max-line-length
                        'templateOptions.disabled': 'model.sac_care_planning_services || model.sac_caregiver_support_services || model.sac_community_day_services || model.sac_legal_services || model.sac_emergency_assistance_and_material_aid_services || model.sac_financial_planning_services || model.sac_housing_and_relocation_services || model.sac_in_home_assistance_services || model.sac_education_employment_training_services || model.sac_medical_and_dental_services || model.sac_medical_rehabilitation_services || model.sac_mental_health_services || model.sac_nutrition || model.sac_public_assistance_benefits || model.sac_substance_use_services || model.sac_transportation || model.sac_victim_services || model.sac_other_services'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  closing_summary: [
    {
      id: 'closing_summary',
      className: 'col-12',
      fieldGroupClassName: 'row',
      wrappers: [
        'getcare-panel'
      ],
      templateOptions: {
        label: 'Closing Summary',
        open: true,
        placeholder: '',
        isDisabled: true
      },
      fieldGroup: [
        {
          wrappers: [
            'getcare-panel'
          ],
          templateOptions: {
            label: '   ',
            open: true,
            isDisabled: true
          },
          className: 'col-12',
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              type: 'getcare-text',
              key: 'aps_case_load_id',
              templateOptions: {
                label: 'Case #:',
                labelClass: 'col-lg-6 col-12',
                valueClass: 'col-lg-6 col-12',
                inline: true
              },
              className: 'col-lg-3 col-12',
              wrappers: [
                'getcare-form-field'
              ]
            },
            {
              type: 'getcare-text',
              key: 'report_received_date',
              templateOptions: {
                label: 'Report Start Date:',
                labelClass: 'col-lg-5 col-12',
                valueClass: 'col-lg-7 col-12',
                inline: true
              },
              className: 'col-lg-4 col-12',
              wrappers: [
                'getcare-form-field'
              ]
            },
            {
              type: 'getcare-text',
              key: 'investigation_start_date',
              templateOptions: {
                label: 'Investigation Start Date:',
                labelClass: 'col-lg-7 col-12',
                valueClass: 'col-lg-5 col-12',
                inline: true
              },
              className: 'col-lg-5 col-12',
              wrappers: [
                'getcare-form-field'
              ]
            },
            {
              className: 'col-lg-6 col-12 mt-2',
              type: 'getcare-date',
              key: 'disposition_date',
              templateOptions: {
                label: 'Investigation Disposition Date:',
                fieldClass: 'form-control form-control-lg',
                attributes: {
                  required: 'true'
                }
              }
            },
            {
              className: 'col-lg-6 col-12 mt-2',
              type: 'getcare-date',
              key: 'case_close_date',
              templateOptions: {
                label: 'Case Close Date:',
                fieldClass: 'form-control form-control-lg'
              }
            },
            {
              className: 'col-12 mt-2',
              type: 'getcare-multiple-checkbox',
              key: 'aps_inter_agency_coordinations',
              templateOptions: {
                type: 'array',
                label: 'Interagency Coordination:',
                formCheck: 'inline',
                columnClass: 'col-lg-4 col-md-6 mt-2',
                functionToRun: 'noneOnly',
                optionArr: [
                  {
                    value: 'DHW Adult Development Disability Services',
                    label: 'DHW Adult Development Disability Services',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'DHW Bureau Of Facility Standards',
                    label: 'DHW Bureau Of Facility Standards',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'DHW Mental Health Services Referral',
                    label: 'DHW Mental Health Services Referral',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Information And Assistance',
                    label: 'Information And Assistance',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Law Enforcement',
                    label: 'Law Enforcement',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'LTC Ombudsman',
                    label: 'LTC Ombudsman',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Social Security',
                    label: 'Social Security',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'DHW Medicaid Fraud',
                    label: 'DHW Medicaid Fraud',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Justice Center',
                    label: 'Justice Center',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Disability Rights Idaho',
                    label: 'Disability Rights Idaho',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'Veterans Administration',
                    label: 'Veterans Administration',
                    disabled: false,
                    isNone: false,
                  },
                  {
                    value: 'None',
                    label: 'None',
                    disabled: false,
                    isNone: true,
                  },
                  {
                    value: 'Other',
                    label: 'Other',
                    disabled: false,
                    isNone: false,
                  }
                ]
              }
            },
            {
              className: 'col-12',
              fieldGroupClassName: 'row',
              fieldGroup: [
                {
                  className: 'col-lg-4 col-md-4 col-12',
                  type: 'getcare-input',
                  key: 'other_interagency_coordination',
                  templateOptions: {
                    hideLabel: true,
                    fieldClass: 'form-control form-control-lg'
                  },
                  hideExpression: (model: any) => {
                    // access to the main model can be through `this.model` or `formState` or `model
                    if (model.aps_inter_agency_coordinations) {
                      return !model.aps_inter_agency_coordinations.includes('Other');
                    }
                    return false;
                  },
                  expressionProperties: {
                    'model.other_interagency_coordination': (model: any) => {
                      // access to the main model can be through `this.model` or `formState` or `model
                      if (model.aps_inter_agency_coordinations) {
                        return model.aps_inter_agency_coordinations.includes('Other') ? model.other_interagency_coordination : '';
                      }
                    }
                  }
                }
              ]
            },
            {
              key: 'aps_findings_outcomes',
              className: 'col-12',
              fieldGroupClassName: 'row',
              fieldGroup: [
                {
                  type: 'getcare-repeat-component',
                  className: 'col-12 mb-2 mt-2',
                  templateOptions: {
                    hideAddTextLabel: true,
                    hideRemoveTextLabel: true
                  },
                  fieldArray: {
                    fieldGroupClassName: 'mb-2 row',
                    fieldGroup: [
                      {
                        className: 'w-100 font-weight-bold',
                        key: 'type_of_maltreatment',
                        type: 'getcare-text'
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        key: 'findings',
                        fieldGroup: [
                          {
                            type: 'getcare-select',
                            key: 'name',
                            templateOptions: {
                              label: 'Findings:',
                              placeholder: ' ',
                              lookUpType: 'findings',
                              required: true,
                              fieldClass: 'form-control form-control-lg',
                              change: (field) => {
                                if (field.formControl.value === 'Substantiated') {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('Substantiate');
                                } else if (field.formControl.value === '' || field.formControl.value === undefined
                                || field.formControl.value === null)  {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('');
                                } else {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('Unsubstantiated');
                                }
                              }
                            },
                            hooks: {
                              onInit: field => {
                                if (field.formControl.value === 'Substantiated') {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('Substantiate');
                                } else if (field.formControl.value === '' || field.formControl.value === undefined
                                || field.formControl.value === null)  {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('');
                                } else {
                                  field.parent.parent.formControl.get('outcome').get('sub_type').setValue('Unsubstantiated');
                                }
                              }
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'look_up_type',
                            className: 'd-none',
                            defaultValue: 'ApsFindings',
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'enabled',
                            className: 'd-none',
                            defaultValue: true,
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          }
                        ]
                      },
                      {
                        className: 'col-lg-6 col-md-6 col-12',
                        key: 'outcome',
                        fieldGroup: [
                          {
                            type: 'getcare-select',
                            key: 'name',
                            templateOptions: {
                              label: 'Outcome:',
                              placeholder: ' ',
                              lookUpType: '',
                              required: true,
                              fieldClass: 'form-control form-control-lg',
                              cascadingList: {
                                substantiated: 'outcome_substantiate',
                                unable_to_substantiate: 'outcome_unsubstantiated',
                                not_substantiated: 'outcome_unsubstantiated'
                              }
                            },
                            hooks: {
                              onInit: field => {
                                let ctr = 0;
                                const fieldVal = field.parent.parent.form.controls[0].get('findings').get('name');
                                field.parent.parent.form.controls[0].get('findings').get('name').valueChanges.pipe(
                                  takeUntil(onDestroy$),
                                  startWith(fieldVal.value),
                                  tap(item => {
                                    const optData = {
                                      outcome_substantiate: [
                                        {
                                          value:  'Victim Declined',
                                          label:  'Victim Declined'
                                        },
                                        {
                                          value:  'Voluntary Services Consent',
                                          label:  'Voluntary Services Consent'
                                        },
                                        {
                                          value:  'Involuntary Services Needed',
                                          label:  'Involuntary Services Needed'
                                        }
                                      ],
                                      outcome_unsubstantiated: [
                                        {
                                          value: 'Voluntary Services Consent',
                                          label: 'Voluntary Services Consent'
                                        },
                                        {
                                          value: 'Client Referrals Requested/Provided',
                                          label: 'Client Referrals Requested/Provided'
                                        },
                                        {
                                          value: 'Client Referrals Requested/Unavailable',
                                          label: 'Client Referrals Requested/Unavailable'
                                        },
                                        {
                                          value: 'No Additional Client Needs Identified',
                                          label: 'No Additional Client Needs Identified'
                                        }
                                      ]
                                    };
                                    if (item !== undefined && item !== null && item !== '') {
                                      item = item.replace(/ /g, '_');
                                      field.templateOptions.lookUpType = field.templateOptions.cascadingList[item.toLowerCase()];
                                      field.templateOptions.options = optData[field.templateOptions.cascadingList[item.toLowerCase()]];
                                    } else {
                                      field.templateOptions.options = [];
                                    }
                                    if (ctr !== 0) {
                                      field.formControl.setValue('');
                                    }
                                    ctr++;
                                  }),
                                ).subscribe();
                              },
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'look_up_type',
                            className: 'd-none',
                            defaultValue: 'ApsOutcome',
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'enabled',
                            className: 'd-none',
                            defaultValue: true,
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'sub_type',
                            className: 'd-none',
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          },
                        ]
                      },
                      {
                        className: 'col-12',
                        key: 'client_risk_conclusion',
                        fieldGroup: [
                          {
                            type: 'getcare-select',
                            key: 'name',
                            templateOptions: {
                              label: 'Client Risk Conclusion:',
                              placeholder: ' ',
                              lookUpType: 'client_risk_conclusion',
                              required: true,
                              fieldClass: 'form-control form-control-lg'
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'look_up_type',
                            className: 'd-none',
                            defaultValue: 'ClientRiskConclusion',
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          },
                          {
                            type: 'getcare-input',
                            key: 'enabled',
                            className: 'd-none',
                            defaultValue: true,
                            templateOptions: {
                              type: 'hidden',
                              hideLabel: true
                            }
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            },
            {
              className: 'col-lg-6 col-12',
              key: 'did_aps_enter_home',
              fieldGroup: [
                {
                  type: 'getcare-select',
                  key: 'name',
                  templateOptions: {
                    label: 'Did APS enter the home?',
                    placeholder: ' ',
                    lookUpType: 'yes_no',
                    required: true,
                    fieldClass: 'form-control form-control-lg'
                  }
                },
                {
                  type: 'getcare-input',
                  key: 'look_up_type',
                  className: 'd-none',
                  defaultValue: 'YesNo',
                  templateOptions: {
                    type: 'hidden',
                    hideLabel: true
                  }
                },
                {
                  type: 'getcare-input',
                  key: 'enabled',
                  defaultValue: true,
                  templateOptions: {
                    type: 'hidden',
                    hideLabel: true
                  }
                }
              ]
            },
            {
              type: 'getcare-input',
              key: 'reason_aps_did_not_enter_home',
              templateOptions: {
                label: 'Reason APS did not enter home:'
              },
              className: 'col-lg-6 col-12',
              expressionProperties: {
                'templateOptions.disabled': 'model.did_aps_enter_home.name !== "No"',
                'model.reason_aps_did_not_enter_home': (model: any) => {
                  if (model.did_aps_enter_home.name !== 'No') {
                    return '';
                  }
                  return model.reason_aps_did_not_enter_home;
                }
              }
            },
            {
              className: 'col-12',
              key: 'reason_for_closure',
              fieldGroup: [
                {
                  type: 'getcare-select',
                  key: 'name',
                  templateOptions: {
                    label: 'Reason for Closure:',
                    placeholder: ' ',
                    lookUpType: 'reason_for_closure',
                    required: true,
                    fieldClass: 'form-control form-control-lg'
                  }
                },
                {
                  type: 'getcare-input',
                  key: 'look_up_type',
                  className: 'd-none',
                  defaultValue: 'ApsReasonForClosure',
                  templateOptions: {
                    type: 'hidden',
                    hideLabel: true
                  }
                },
                {
                  type: 'getcare-input',
                  key: 'enabled',
                  className: 'd-none',
                  defaultValue: true,
                  templateOptions: {
                    type: 'hidden',
                    hideLabel: true
                  }
                }
              ]
            },
            {
              className: 'col-12',
              type: 'getcare-checkbox',
              key: 'fcc_only',
              templateOptions: {
                label: 'FCC Only'
              }
            }
          ]
        },
        {
          className: 'col-12 mt-3',
          type: 'getcare-rich-text-editor',
          key: 'conclusion_justification',
          templateOptions: {
            label: 'Conclusion Justification:',
            rows: 5,
            fieldClass: 'form-control form-control-lg'
          }
        },
        {
          className: 'col-lg-6 col-12',
          type: 'getcare-input',
          key: 'completed_by_name',
          templateOptions: {
            label: 'Completed By:',
            disabled: true,
            fieldClass: 'form-control form-control-lg'
          }
        },
        {
          className: 'col-lg-6 col-12',
          type: 'getcare-date',
          key: 'completed_date',
          templateOptions: {
            label: 'Completed Date:',
            disabled: true,
            fieldClass: 'form-control form-control-lg'
          }
        }
      ]
    }
  ],
};
